!function (s) {
    "use strict";
    s.fn.menumaker = function (t) {
        var e = s(this), i = s.extend({format: "dropdown", sticky: !1}, t);
        return this.each(function () {
            // s(this).find(".navbar-toggler").on("click", function () {
            //     s(this).toggleClass("menu-opened");
            //     var t = s(this).next("ul");
            //     t.hasClass("open") ? t.slideToggle().removeClass("open") : (t.slideToggle().addClass("open"), "dropdown" === i.format && t.find("ul").show())
            // }),
                e.find(".navbar-nav li ul").parent().addClass("has-sub"), e.find(".navbar-nav li ul li").parent().addClass("sub-menu");
            // "multitoggle" === i.format ? (e.find(".has-sub").prepend('<span class="submenu-button"></span>'), e.find(".navbar-nav > li.has-sub > .submenu-button").on("click", function () {
            //     s(this).next(".sub-menu").slideToggle(), s(this).siblings("ul").addClass("open").slideToggle(), s(this).parents(".navbar-nav > li.has-sub").toggleClass("active").siblings(".has-sub").children(".sub-menu").slideUp().removeClass("open").parents("li").removeClass("active")
            // }), e.find(".sub-menu > li.has-sub > .submenu-button").on("click", function () {
            //     s(this).next(".sub-menu").slideToggle(), s(this).siblings("ul").addClass("open").slideToggle(), s(this).parents(".sub-menu > li").toggleClass("active").siblings(".has-sub").children(".sub-menu").slideUp().removeClass("open").parents("li").removeClass("active"), s(this).siblings("ul").hasClass("open") && s(this).parents("li").eq(1).addClass("active")
            // })) : e.addClass("dropdown"), !0 === i.sticky && e.css("position", "fixed");

            function t() {
                991 < s(window).width() && e.find("ul").show()
            }

            return t(), s(window).on("resize", t)
        })
    },
        s(document).ready(function () {
        s("nav").menumaker({format: "multitoggle"});
        var t = window.location.pathname.split("/"), e = window.location.pathname,
            e = 0 < t[t.length - 1].length ? t[t.length - 1] : t[t.length - 2];
        s(".navbar-nav li").find('a[href="' + e + '"]').closest("li").addClass("active").parents().eq(1).addClass("current"), s(".navbar-nav li.has-sub ul li").find('a[href="' + e + '"]').parents().eq(4).addClass("current")
    }),
        s(".navbar-default .attr-nav").each(function () {
        s("li.search > a", this).on("click", function (t) {
            t.preventDefault(), s(".top-search").slideToggle()
        })
    }), s(".input-group-addon.close-search").on("click", function () {
        s(".top-search").slideUp()
    })
}(jQuery), function (g) {
    g.fn.extend({
        easyResponsiveTabs: function (l) {
            var c = (l = g.extend({
                    type: "default",
                    width: "auto",
                    fit: !0,
                    closed: !1,
                    tabidentify: "",
                    activate: function () {
                    }
                }, l)).type, d = l.fit, h = l.width, u = window.location.hash,
                p = !(!window.history || !history.replaceState);
            g(this).on("bind", "tabactivate", function (t, e) {
                "function" == typeof l.activate && l.activate.call(e, t)
            }), this.each(function () {
                var i, s = g(this), t = s.find("ul.resp-tabs-list." + l.tabidentify), o = s.attr("id");
                s.find("ul.resp-tabs-list." + l.tabidentify + " li").addClass("resp-tab-item").addClass(l.tabidentify), s.css({
                    display: "block",
                    width: h
                }), "vertical" == l.type && s.find(".resp-tabs-container." + l.tabidentify).css("border-color", l.active_content_border_color), s.find(".resp-tabs-container." + l.tabidentify + " > div").addClass("resp-tab-content").addClass(l.tabidentify), "vertical" == c && s.addClass("resp-vtabs").addClass(l.tabidentify), 1 == d && s.css({
                    width: "100%",
                    margin: "0px"
                }), "accordion" == c && (s.addClass("resp-easy-accordion").addClass(l.tabidentify), s.find(".resp-tabs-list").css("display", "none")), s.find(".resp-tab-content." + l.tabidentify).before("<h2 class='resp-accordion " + l.tabidentify + "' role='tab'><span class='resp-arrow'></span></h2>"), s.find(".resp-tab-content." + l.tabidentify).prev("h2").css({
                    "background-color": l.inactive_bg,
                    "border-color": l.active_border_color
                });
                var n = 0;
                s.find(".resp-accordion").each(function () {
                    i = g(this);
                    var t = s.find(".resp-tab-item:eq(" + n + ")"), e = s.find(".resp-accordion:eq(" + n + ")");
                    e.append(t.html()), e.data(t.data()), i.attr("aria-controls", l.tabidentify + "_tab_item-" + n), n++
                });
                var e = 0;
                s.find(".resp-tab-item").each(function () {
                    $tabItem = g(this), $tabItem.attr("aria-controls", l.tabidentify + "_tab_item-" + e), $tabItem.attr("role", "tab"), $tabItem.css({
                        "background-color": l.inactive_bg,
                        "border-color": "none"
                    });
                    var t = 0;
                    s.find(".resp-tab-content." + l.tabidentify).each(function () {
                        g(this).attr("aria-labelledby", l.tabidentify + "_tab_item-" + t).css({"border-color": l.active_border_color}), t++
                    }), e++
                });
                var r, a = 0;
                "" == u || null !== (r = u.match(new RegExp(o + "([0-9]+)"))) && 2 === r.length && (a = parseInt(r[1], 10) - 1, e < a && (a = 0)), g(s.find(".resp-tab-item." + l.tabidentify)[a]).addClass("resp-tab-active").css({
                    "background-color": l.activetab_bg,
                    "border-color": l.active_border_color
                }), !0 === l.closed || "accordion" === l.closed && !t.is(":visible") || "tabs" === l.closed && t.is(":visible") || (g(s.find(".resp-accordion." + l.tabidentify)[a]).addClass("resp-tab-active").css({
                    "background-color": l.activetab_bg + " !important",
                    "border-color": l.active_border_color,
                    background: "none"
                }), g(s.find(".resp-tab-content." + l.tabidentify)[a]).addClass("resp-tab-content-active").addClass(l.tabidentify).attr("style", "display:block")), s.find("[role=tab]").each(function () {
                    g(this).on("click", function () {
                        var t, e = g(this), i = e.attr("aria-controls");
                        if (e.hasClass("resp-accordion") && e.hasClass("resp-tab-active")) return s.find(".resp-tab-content-active." + l.tabidentify).slideUp("", function () {
                            g(this).addClass("resp-accordion-closed")
                        }), e.removeClass("resp-tab-active").css({}), !1;
                        !e.hasClass("resp-tab-active") && e.hasClass("resp-accordion") ? (s.find(".resp-tab-active." + l.tabidentify).removeClass("resp-tab-active").css({}), s.find(".resp-tab-content-active." + l.tabidentify).slideUp().removeClass("resp-tab-content-active resp-accordion-closed"), s.find("[aria-controls=" + i + "]").addClass("resp-tab-active").css({}), s.find(".resp-tab-content[aria-labelledby = " + i + "]." + l.tabidentify).slideDown().addClass("resp-tab-content-active")) : (s.find(".resp-tab-active." + l.tabidentify).removeClass("resp-tab-active").css({}), s.find(".resp-tab-content-active." + l.tabidentify).removeAttr("style").removeClass("resp-tab-content-active").removeClass("resp-accordion-closed"), s.find("[aria-controls=" + i + "]").addClass("resp-tab-active").css({}), s.find(".resp-tab-content[aria-labelledby = " + i + "]." + l.tabidentify).addClass("resp-tab-content-active").attr("style", "display:block")), e.trigger("tabactivate", e), p && (t = window.location.hash, i.split("tab_item-"), e = (e = "") != t ? (i = new RegExp(o + "[0-9]+"), null != t.match(i) ? t.replace(i, e) : t + "|" + e) : "" + e, history.replaceState(null, null, e))
                    })
                }), g(window).resize(function () {
                    s.find(".resp-accordion-closed").removeAttr("style")
                })
            })
        }
    })
}(jQuery), function (l, i, s, a) {
    function c(t, e) {
        this.settings = null, this.options = l.extend({}, c.Defaults, e), this.$element = l(t), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = {
            time: null,
            target: null,
            pointer: null,
            stage: {start: null, current: null},
            direction: null
        }, this._states = {
            current: {},
            tags: {initializing: ["busy"], animating: ["busy"], dragging: ["interacting"]}
        }, l.each(["onResize", "onThrottledResize"], l.proxy(function (t, e) {
            this._handlers[e] = l.proxy(this[e], this)
        }, this)), l.each(c.Plugins, l.proxy(function (t, e) {
            this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(this)
        }, this)), l.each(c.Workers, l.proxy(function (t, e) {
            this._pipe.push({filter: e.filter, run: l.proxy(e.run, this)})
        }, this)), this.setup(), this.initialize()
    }

    c.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        checkVisibility: !0,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: i,
        fallbackEasing: "swing",
        slideTransition: "",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab"
    }, c.Width = {Default: "default", Inner: "inner", Outer: "outer"}, c.Type = {
        Event: "event",
        State: "state"
    }, c.Plugins = {}, c.Workers = [{
        filter: ["width", "settings"], run: function () {
            this._width = this.$element.width()
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            t.current = this._items && this._items[this.relative(this._current)]
        }
    }, {
        filter: ["items", "settings"], run: function () {
            this.$stage.children(".cloned").remove()
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            var e = this.settings.margin || "", i = !this.settings.autoWidth, s = this.settings.rtl,
                e = {width: "auto", "margin-left": s ? e : "", "margin-right": s ? "" : e};
            i || this.$stage.children().css(e), t.css = e
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            var e = (this.width() / this.settings.items).toFixed(3) - this.settings.margin, i = null,
                s = this._items.length, o = !this.settings.autoWidth, n = [];
            for (t.items = {
                merge: !1,
                width: e
            }; s--;) i = this._mergers[s], i = this.settings.mergeFit && Math.min(i, this.settings.items) || i, t.items.merge = 1 < i || t.items.merge, n[s] = o ? e * i : this._items[s].width();
            this._widths = n
        }
    }, {
        filter: ["items", "settings"], run: function () {
            var t = [], e = this._items, i = this.settings, s = Math.max(2 * i.items, 4),
                o = 2 * Math.ceil(e.length / 2), n = i.loop && e.length ? i.rewind ? s : Math.max(s, o) : 0, r = "",
                a = "";
            for (n /= 2; 0 < n;) t.push(this.normalize(t.length / 2, !0)), r += e[t[t.length - 1]][0].outerHTML, t.push(this.normalize(e.length - 1 - (t.length - 1) / 2, !0)), a = e[t[t.length - 1]][0].outerHTML + a, --n;
            this._clones = t, l(r).addClass("cloned").appendTo(this.$stage), l(a).addClass("cloned").prependTo(this.$stage)
        }
    }, {
        filter: ["width", "items", "settings"], run: function () {
            for (var t, e, i = this.settings.rtl ? 1 : -1, s = this._clones.length + this._items.length, o = -1, n = []; ++o < s;) t = n[o - 1] || 0, e = this._widths[this.relative(o)] + this.settings.margin, n.push(t + e * i);
            this._coordinates = n
        }
    }, {
        filter: ["width", "items", "settings"], run: function () {
            var t = this.settings.stagePadding, e = this._coordinates, t = {
                width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t,
                "padding-left": t || "",
                "padding-right": t || ""
            };
            this.$stage.css(t)
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            var e = this._coordinates.length, i = !this.settings.autoWidth, s = this.$stage.children();
            if (i && t.items.merge) for (; e--;) t.css.width = this._widths[this.relative(e)], s.eq(e).css(t.css); else i && (t.css.width = t.items.width, s.css(t.css))
        }
    }, {
        filter: ["items"], run: function () {
            this._coordinates.length < 1 && this.$stage.removeAttr("style")
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            t.current = t.current ? this.$stage.children().index(t.current) : 0, t.current = Math.max(this.minimum(), Math.min(this.maximum(), t.current)), this.reset(t.current)
        }
    }, {
        filter: ["position"], run: function () {
            this.animate(this.coordinates(this._current))
        }
    }, {
        filter: ["width", "position", "items", "settings"], run: function () {
            for (var t, e, i = this.settings.rtl ? 1 : -1, s = 2 * this.settings.stagePadding, o = this.coordinates(this.current()) + s, n = o + this.width() * i, r = [], a = 0, l = this._coordinates.length; a < l; a++) t = this._coordinates[a - 1] || 0, e = Math.abs(this._coordinates[a]) + s * i, (this.op(t, "<=", o) && this.op(t, ">", n) || this.op(e, "<", o) && this.op(e, ">", n)) && r.push(a);
            this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + r.join("), :eq(") + ")").addClass("active"), this.$stage.children(".center").removeClass("center"), this.settings.center && this.$stage.children().eq(this.current()).addClass("center")
        }
    }], c.prototype.initializeStage = function () {
        this.$stage = this.$element.find("." + this.settings.stageClass), this.$stage.length || (this.$element.addClass(this.options.loadingClass), this.$stage = l("<" + this.settings.stageElement + ">", {class: this.settings.stageClass}).wrap(l("<div/>", {class: this.settings.stageOuterClass})), this.$element.append(this.$stage.parent()))
    }, c.prototype.initializeItems = function () {
        var t = this.$element.find(".owl-item");
        if (t.length) return this._items = t.get().map(function (t) {
            return l(t)
        }), this._mergers = this._items.map(function () {
            return 1
        }), void this.refresh();
        this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)
    }, c.prototype.initialize = function () {
        var t, e;
        this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading") && (t = this.$element.find("img"), e = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : a, e = this.$element.children(e).width(), t.length && e <= 0 && this.preloadAutoWidthImages(t)), this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized")
    }, c.prototype.isVisible = function () {
        return !this.settings.checkVisibility || this.$element.is(":visible")
    }, c.prototype.setup = function () {
        var e = this.viewport(), t = this.options.responsive, i = -1, s = null;
        t ? (l.each(t, function (t) {
            t <= e && i < t && (i = Number(t))
        }), "function" == typeof (s = l.extend({}, this.options, t[i])).stagePadding && (s.stagePadding = s.stagePadding()), delete s.responsive, s.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + i))) : s = l.extend({}, this.options), this.trigger("change", {
            property: {
                name: "settings",
                value: s
            }
        }), this._breakpoint = i, this.settings = s, this.invalidate("settings"), this.trigger("changed", {
            property: {
                name: "settings",
                value: this.settings
            }
        })
    }, c.prototype.optionsLogic = function () {
        this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
    }, c.prototype.prepare = function (t) {
        var e = this.trigger("prepare", {content: t});
        return e.data || (e.data = l("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(t)), this.trigger("prepared", {content: e.data}), e.data
    }, c.prototype.update = function () {
        for (var t = 0, e = this._pipe.length, i = l.proxy(function (t) {
            return this[t]
        }, this._invalidated), s = {}; t < e;) (this._invalidated.all || 0 < l.grep(this._pipe[t].filter, i).length) && this._pipe[t].run(s), t++;
        this._invalidated = {}, this.is("valid") || this.enter("valid")
    }, c.prototype.width = function (t) {
        switch (t = t || c.Width.Default) {
            case c.Width.Inner:
            case c.Width.Outer:
                return this._width;
            default:
                return this._width - 2 * this.settings.stagePadding + this.settings.margin
        }
    }, c.prototype.refresh = function () {
        this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed")
    }, c.prototype.onThrottledResize = function () {
        i.clearTimeout(this.resizeTimer), this.resizeTimer = i.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
    }, c.prototype.onResize = function () {
        return !!this._items.length && (this._width !== this.$element.width() && (!!this.isVisible() && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))))
    }, c.prototype.registerEventHandlers = function () {
        l.support.transition && this.$stage.on(l.support.transition.end + ".owl.core", l.proxy(this.onTransitionEnd, this)), !1 !== this.settings.responsive && this.on(i, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", l.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
            return !1
        })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", l.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", l.proxy(this.onDragEnd, this)))
    }, c.prototype.onDragStart = function (t) {
        var e = null;
        3 !== t.which && (e = l.support.transform ? {
            x: (e = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","))[16 === e.length ? 12 : 4],
            y: e[16 === e.length ? 13 : 5]
        } : (e = this.$stage.position(), {
            x: this.settings.rtl ? e.left + this.$stage.width() - this.width() + this.settings.margin : e.left,
            y: e.top
        }), this.is("animating") && (l.support.transform ? this.animate(e.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === t.type), this.speed(0), this._drag.time = (new Date).getTime(), this._drag.target = l(t.target), this._drag.stage.start = e, this._drag.stage.current = e, this._drag.pointer = this.pointer(t), l(s).on("mouseup.owl.core touchend.owl.core", l.proxy(this.onDragEnd, this)), l(s).one("mousemove.owl.core touchmove.owl.core", l.proxy(function (t) {
            var e = this.difference(this._drag.pointer, this.pointer(t));
            l(s).on("mousemove.owl.core touchmove.owl.core", l.proxy(this.onDragMove, this)), Math.abs(e.x) < Math.abs(e.y) && this.is("valid") || (t.preventDefault(), this.enter("dragging"), this.trigger("drag"))
        }, this)))
    }, c.prototype.onDragMove = function (t) {
        var e, i = null, s = null, o = this.difference(this._drag.pointer, this.pointer(t)),
            n = this.difference(this._drag.stage.start, o);
        this.is("dragging") && (t.preventDefault(), this.settings.loop ? (i = this.coordinates(this.minimum()), s = this.coordinates(this.maximum() + 1) - i, n.x = ((n.x - i) % s + s) % s + i) : (i = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), s = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), e = this.settings.pullDrag ? -1 * o.x / 5 : 0, n.x = Math.max(Math.min(n.x, i + e), s + e)), this._drag.stage.current = n, this.animate(n.x))
    }, c.prototype.onDragEnd = function (t) {
        var e = this.difference(this._drag.pointer, this.pointer(t)), i = this._drag.stage.current,
            t = 0 < e.x ^ this.settings.rtl ? "left" : "right";
        l(s).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== e.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(i.x, 0 !== e.x ? t : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = t, (3 < Math.abs(e.x) || 300 < (new Date).getTime() - this._drag.time) && this._drag.target.one("click.owl.core", function () {
            return !1
        })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"))
    }, c.prototype.closest = function (i, s) {
        var o = -1, n = this.width(), r = this.coordinates();
        return this.settings.freeDrag || l.each(r, l.proxy(function (t, e) {
            return "left" === s && e - 30 < i && i < e + 30 ? o = t : "right" === s && e - n - 30 < i && i < e - n + 30 ? o = t + 1 : this.op(i, "<", e) && this.op(i, ">", r[t + 1] !== a ? r[t + 1] : e - n) && (o = "left" === s ? t + 1 : t), -1 === o
        }, this)), this.settings.loop || (this.op(i, ">", r[this.minimum()]) ? o = i = this.minimum() : this.op(i, "<", r[this.maximum()]) && (o = i = this.maximum())), o
    }, c.prototype.animate = function (t) {
        var e = 0 < this.speed();
        this.is("animating") && this.onTransitionEnd(), e && (this.enter("animating"), this.trigger("translate")), l.support.transform3d && l.support.transition ? this.$stage.css({
            transform: "translate3d(" + t + "px,0px,0px)",
            transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
        }) : e ? this.$stage.animate({left: t + "px"}, this.speed(), this.settings.fallbackEasing, l.proxy(this.onTransitionEnd, this)) : this.$stage.css({left: t + "px"})
    }, c.prototype.is = function (t) {
        return this._states.current[t] && 0 < this._states.current[t]
    }, c.prototype.current = function (t) {
        return t === a ? this._current : 0 === this._items.length ? a : (t = this.normalize(t), this._current !== t && ((e = this.trigger("change", {
            property: {
                name: "position",
                value: t
            }
        })).data !== a && (t = this.normalize(e.data)), this._current = t, this.invalidate("position"), this.trigger("changed", {
            property: {
                name: "position",
                value: this._current
            }
        })), this._current);
        var e
    }, c.prototype.invalidate = function (t) {
        return "string" === l.type(t) && (this._invalidated[t] = !0, this.is("valid") && this.leave("valid")), l.map(this._invalidated, function (t, e) {
            return e
        })
    }, c.prototype.reset = function (t) {
        (t = this.normalize(t)) !== a && (this._speed = 0, this._current = t, this.suppress(["translate", "translated"]), this.animate(this.coordinates(t)), this.release(["translate", "translated"]))
    }, c.prototype.normalize = function (t, e) {
        var i = this._items.length, e = e ? 0 : this._clones.length;
        return !this.isNumeric(t) || i < 1 ? t = a : (t < 0 || i + e <= t) && (t = ((t - e / 2) % i + i) % i + e / 2), t
    }, c.prototype.relative = function (t) {
        return t -= this._clones.length / 2, this.normalize(t, !0)
    }, c.prototype.maximum = function (t) {
        var e, i, s, o = this.settings, n = this._coordinates.length;
        if (o.loop) n = this._clones.length / 2 + this._items.length - 1; else if (o.autoWidth || o.merge) {
            if (e = this._items.length) for (i = this._items[--e].width(), s = this.$element.width(); e-- && !(s < (i += this._items[e].width() + this.settings.margin));) ;
            n = e + 1
        } else n = o.center ? this._items.length - 1 : this._items.length - o.items;
        return t && (n -= this._clones.length / 2), Math.max(n, 0)
    }, c.prototype.minimum = function (t) {
        return t ? 0 : this._clones.length / 2
    }, c.prototype.items = function (t) {
        return t === a ? this._items.slice() : (t = this.normalize(t, !0), this._items[t])
    }, c.prototype.mergers = function (t) {
        return t === a ? this._mergers.slice() : (t = this.normalize(t, !0), this._mergers[t])
    }, c.prototype.clones = function (i) {
        function s(t) {
            return t % 2 == 0 ? o + t / 2 : e - (t + 1) / 2
        }

        var e = this._clones.length / 2, o = e + this._items.length;
        return i === a ? l.map(this._clones, function (t, e) {
            return s(e)
        }) : l.map(this._clones, function (t, e) {
            return t === i ? s(e) : null
        })
    }, c.prototype.speed = function (t) {
        return t !== a && (this._speed = t), this._speed
    }, c.prototype.coordinates = function (t) {
        var e, i = 1, s = t - 1;
        return t === a ? l.map(this._coordinates, l.proxy(function (t, e) {
            return this.coordinates(e)
        }, this)) : (this.settings.center ? (this.settings.rtl && (i = -1, s = t + 1), e = this._coordinates[t], e += (this.width() - e + (this._coordinates[s] || 0)) / 2 * i) : e = this._coordinates[s] || 0, e = Math.ceil(e))
    }, c.prototype.duration = function (t, e, i) {
        return 0 === i ? 0 : Math.min(Math.max(Math.abs(e - t), 1), 6) * Math.abs(i || this.settings.smartSpeed)
    }, c.prototype.to = function (t, e) {
        var i, s = this.current(), o = t - this.relative(s), n = (0 < o) - (o < 0), r = this._items.length,
            a = this.minimum(), l = this.maximum();
        this.settings.loop ? (!this.settings.rewind && Math.abs(o) > r / 2 && (o += -1 * n * r), (i = (((t = s + o) - a) % r + r) % r + a) !== t && i - o <= l && 0 < i - o && (s = i - o, t = i, this.reset(s))) : t = this.settings.rewind ? (t % (l += 1) + l) % l : Math.max(a, Math.min(l, t)), this.speed(this.duration(s, t, e)), this.current(t), this.isVisible() && this.update()
    }, c.prototype.next = function (t) {
        t = t || !1, this.to(this.relative(this.current()) + 1, t)
    }, c.prototype.prev = function (t) {
        t = t || !1, this.to(this.relative(this.current()) - 1, t)
    }, c.prototype.onTransitionEnd = function (t) {
        if (t !== a && (t.stopPropagation(), (t.target || t.srcElement || t.originalTarget) !== this.$stage.get(0))) return !1;
        this.leave("animating"), this.trigger("translated")
    }, c.prototype.viewport = function () {
        var t;
        return this.options.responsiveBaseElement !== i ? t = l(this.options.responsiveBaseElement).width() : i.innerWidth ? t = i.innerWidth : s.documentElement && s.documentElement.clientWidth ? t = s.documentElement.clientWidth : console.warn("Can not detect viewport width."), t
    }, c.prototype.replace = function (t) {
        this.$stage.empty(), this._items = [], t = t && (t instanceof jQuery ? t : l(t)), this.settings.nestedItemSelector && (t = t.find("." + this.settings.nestedItemSelector)), t.filter(function () {
            return 1 === this.nodeType
        }).each(l.proxy(function (t, e) {
            e = this.prepare(e), this.$stage.append(e), this._items.push(e), this._mergers.push(+e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
        }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
    }, c.prototype.add = function (t, e) {
        var i = this.relative(this._current);
        e = e === a ? this._items.length : this.normalize(e, !0), t = t instanceof jQuery ? t : l(t), this.trigger("add", {
            content: t,
            position: e
        }), t = this.prepare(t), 0 === this._items.length || e === this._items.length ? (0 === this._items.length && this.$stage.append(t), 0 !== this._items.length && this._items[e - 1].after(t), this._items.push(t), this._mergers.push(+t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[e].before(t), this._items.splice(e, 0, t), this._mergers.splice(e, 0, +t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[i] && this.reset(this._items[i].index()), this.invalidate("items"), this.trigger("added", {
            content: t,
            position: e
        })
    }, c.prototype.remove = function (t) {
        (t = this.normalize(t, !0)) !== a && (this.trigger("remove", {
            content: this._items[t],
            position: t
        }), this._items[t].remove(), this._items.splice(t, 1), this._mergers.splice(t, 1), this.invalidate("items"), this.trigger("removed", {
            content: null,
            position: t
        }))
    }, c.prototype.preloadAutoWidthImages = function (t) {
        t.each(l.proxy(function (t, e) {
            this.enter("pre-loading"), e = l(e), l(new Image).one("load", l.proxy(function (t) {
                e.attr("src", t.target.src), e.css("opacity", 1), this.leave("pre-loading"), this.is("pre-loading") || this.is("initializing") || this.refresh()
            }, this)).attr("src", e.attr("src") || e.attr("data-src") || e.attr("data-src-retina"))
        }, this))
    }, c.prototype.destroy = function () {
        for (var t in this.$element.off(".owl.core"), this.$stage.off(".owl.core"), l(s).off(".owl.core"), !1 !== this.settings.responsive && (i.clearTimeout(this.resizeTimer), this.off(i, "resize", this._handlers.onThrottledResize)), this._plugins) this._plugins[t].destroy();
        this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.remove(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel")
    }, c.prototype.op = function (t, e, i) {
        var s = this.settings.rtl;
        switch (e) {
            case"<":
                return s ? i < t : t < i;
            case">":
                return s ? t < i : i < t;
            case">=":
                return s ? t <= i : i <= t;
            case"<=":
                return s ? i <= t : t <= i
        }
    }, c.prototype.on = function (t, e, i, s) {
        t.addEventListener ? t.addEventListener(e, i, s) : t.attachEvent && t.attachEvent("on" + e, i)
    }, c.prototype.off = function (t, e, i, s) {
        t.removeEventListener ? t.removeEventListener(e, i, s) : t.detachEvent && t.detachEvent("on" + e, i)
    }, c.prototype.trigger = function (t, e, i, s, o) {
        var n = {item: {count: this._items.length, index: this.current()}},
            r = l.camelCase(l.grep(["on", t, i], function (t) {
                return t
            }).join("-").toLowerCase()),
            a = l.Event([t, "owl", i || "carousel"].join(".").toLowerCase(), l.extend({relatedTarget: this}, n, e));
        return this._supress[t] || (l.each(this._plugins, function (t, e) {
            e.onTrigger && e.onTrigger(a)
        }), this.register({
            type: c.Type.Event,
            name: t
        }), this.$element.trigger(a), this.settings && "function" == typeof this.settings[r] && this.settings[r].call(this, a)), a
    }, c.prototype.enter = function (t) {
        l.each([t].concat(this._states.tags[t] || []), l.proxy(function (t, e) {
            this._states.current[e] === a && (this._states.current[e] = 0), this._states.current[e]++
        }, this))
    }, c.prototype.leave = function (t) {
        l.each([t].concat(this._states.tags[t] || []), l.proxy(function (t, e) {
            this._states.current[e]--
        }, this))
    }, c.prototype.register = function (i) {
        var e;
        i.type === c.Type.Event ? (l.event.special[i.name] || (l.event.special[i.name] = {}), l.event.special[i.name].owl || (e = l.event.special[i.name]._default, l.event.special[i.name]._default = function (t) {
            return !e || !e.apply || t.namespace && -1 !== t.namespace.indexOf("owl") ? t.namespace && -1 < t.namespace.indexOf("owl") : e.apply(this, arguments)
        }, l.event.special[i.name].owl = !0)) : i.type === c.Type.State && (this._states.tags[i.name] ? this._states.tags[i.name] = this._states.tags[i.name].concat(i.tags) : this._states.tags[i.name] = i.tags, this._states.tags[i.name] = l.grep(this._states.tags[i.name], l.proxy(function (t, e) {
            return l.inArray(t, this._states.tags[i.name]) === e
        }, this)))
    }, c.prototype.suppress = function (t) {
        l.each(t, l.proxy(function (t, e) {
            this._supress[e] = !0
        }, this))
    }, c.prototype.release = function (t) {
        l.each(t, l.proxy(function (t, e) {
            delete this._supress[e]
        }, this))
    }, c.prototype.pointer = function (t) {
        var e = {x: null, y: null};
        return (t = (t = t.originalEvent || t || i.event).touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t).pageX ? (e.x = t.pageX, e.y = t.pageY) : (e.x = t.clientX, e.y = t.clientY), e
    }, c.prototype.isNumeric = function (t) {
        return !isNaN(parseFloat(t))
    }, c.prototype.difference = function (t, e) {
        return {x: t.x - e.x, y: t.y - e.y}
    }, l.fn.owlCarousel = function (e) {
        var s = Array.prototype.slice.call(arguments, 1);
        return this.each(function () {
            var t = l(this), i = t.data("owl.carousel");
            i || (i = new c(this, "object" == typeof e && e), t.data("owl.carousel", i), l.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (t, e) {
                i.register({
                    type: c.Type.Event,
                    name: e
                }), i.$element.on(e + ".owl.carousel.core", l.proxy(function (t) {
                    t.namespace && t.relatedTarget !== this && (this.suppress([e]), i[e].apply(this, [].slice.call(arguments, 1)), this.release([e]))
                }, i))
            })), "string" == typeof e && "_" !== e.charAt(0) && i[e].apply(i, s)
        })
    }, l.fn.owlCarousel.Constructor = c
}(window.Zepto || window.jQuery, window, document), function (e, i) {
    var s = function (t) {
        this._core = t, this._interval = null, this._visible = null, this._handlers = {
            "initialized.owl.carousel": e.proxy(function (t) {
                t.namespace && this._core.settings.autoRefresh && this.watch()
            }, this)
        }, this._core.options = e.extend({}, s.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    s.Defaults = {autoRefresh: !0, autoRefreshInterval: 500}, s.prototype.watch = function () {
        this._interval || (this._visible = this._core.isVisible(), this._interval = i.setInterval(e.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
    }, s.prototype.refresh = function () {
        this._core.isVisible() !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh())
    }, s.prototype.destroy = function () {
        var t, e;
        for (t in i.clearInterval(this._interval), this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.AutoRefresh = s
}(window.Zepto || window.jQuery, window, document), function (a, o) {
    var e = function (t) {
        this._core = t, this._loaded = [], this._handlers = {
            "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (t) {
                if (t.namespace && this._core.settings && this._core.settings.lazyLoad && (t.property && "position" == t.property.name || "initialized" == t.type)) {
                    var e = this._core.settings, i = e.center && Math.ceil(e.items / 2) || e.items,
                        s = e.center && -1 * i || 0,
                        o = (t.property && void 0 !== t.property.value ? t.property.value : this._core.current()) + s,
                        n = this._core.clones().length, r = a.proxy(function (t, e) {
                            this.load(e)
                        }, this);
                    for (0 < e.lazyLoadEager && (i += e.lazyLoadEager, e.loop && (o -= e.lazyLoadEager, i++)); s++ < i;) this.load(n / 2 + this._core.relative(o)), n && a.each(this._core.clones(this._core.relative(o)), r), o++
                }
            }, this)
        }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    e.Defaults = {lazyLoad: !1, lazyLoadEager: 0}, e.prototype.load = function (t) {
        var e = this._core.$stage.children().eq(t), t = e && e.find(".owl-lazy");
        !t || -1 < a.inArray(e.get(0), this._loaded) || (t.each(a.proxy(function (t, e) {
            var i = a(e),
                s = 1 < o.devicePixelRatio && i.attr("data-src-retina") || i.attr("data-src") || i.attr("data-srcset");
            this._core.trigger("load", {
                element: i,
                url: s
            }, "lazy"), i.is("img") ? i.one("load.owl.lazy", a.proxy(function () {
                i.css("opacity", 1), this._core.trigger("loaded", {element: i, url: s}, "lazy")
            }, this)).attr("src", s) : i.is("source") ? i.one("load.owl.lazy", a.proxy(function () {
                this._core.trigger("loaded", {element: i, url: s}, "lazy")
            }, this)).attr("srcset", s) : ((e = new Image).onload = a.proxy(function () {
                i.css({"background-image": 'url("' + s + '")', opacity: "1"}), this._core.trigger("loaded", {
                    element: i,
                    url: s
                }, "lazy")
            }, this), e.src = s)
        }, this)), this._loaded.push(e.get(0)))
    }, e.prototype.destroy = function () {
        var t, e;
        for (t in this.handlers) this._core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, a.fn.owlCarousel.Constructor.Plugins.Lazy = e
}(window.Zepto || window.jQuery, window, document), function (o, i) {
    var s = function (t) {
        this._core = t, this._previousHeight = null, this._handlers = {
            "initialized.owl.carousel refreshed.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.autoHeight && this.update()
            }, this), "changed.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.autoHeight && "position" === t.property.name && this.update()
            }, this), "loaded.owl.lazy": o.proxy(function (t) {
                t.namespace && this._core.settings.autoHeight && t.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
            }, this)
        }, this._core.options = o.extend({}, s.Defaults, this._core.options), this._core.$element.on(this._handlers), this._intervalId = null;
        var e = this;
        o(i).on("load", function () {
            e._core.settings.autoHeight && e.update()
        }), o(i).resize(function () {
            e._core.settings.autoHeight && (null != e._intervalId && clearTimeout(e._intervalId), e._intervalId = setTimeout(function () {
                e.update()
            }, 250))
        })
    };
    s.Defaults = {autoHeight: !1, autoHeightClass: "owl-height"}, s.prototype.update = function () {
        var t = this._core._current, e = t + this._core.settings.items, i = this._core.settings.lazyLoad,
            t = this._core.$stage.children().toArray().slice(t, e), s = [], e = 0;
        o.each(t, function (t, e) {
            s.push(o(e).height())
        }), (e = Math.max.apply(null, s)) <= 1 && i && this._previousHeight && (e = this._previousHeight), this._previousHeight = e, this._core.$stage.parent().height(e).addClass(this._core.settings.autoHeightClass)
    }, s.prototype.destroy = function () {
        var t, e;
        for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, o.fn.owlCarousel.Constructor.Plugins.AutoHeight = s
}(window.Zepto || window.jQuery, window, document), function (d, e) {
    var i = function (t) {
        this._core = t, this._videos = {}, this._playing = null, this._handlers = {
            "initialized.owl.carousel": d.proxy(function (t) {
                t.namespace && this._core.register({type: "state", name: "playing", tags: ["interacting"]})
            }, this), "resize.owl.carousel": d.proxy(function (t) {
                t.namespace && this._core.settings.video && this.isInFullScreen() && t.preventDefault()
            }, this), "refreshed.owl.carousel": d.proxy(function (t) {
                t.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
            }, this), "changed.owl.carousel": d.proxy(function (t) {
                t.namespace && "position" === t.property.name && this._playing && this.stop()
            }, this), "prepared.owl.carousel": d.proxy(function (t) {
                var e;
                !t.namespace || (e = d(t.content).find(".owl-video")).length && (e.css("display", "none"), this.fetch(e, d(t.content)))
            }, this)
        }, this._core.options = d.extend({}, i.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", d.proxy(function (t) {
            this.play(t)
        }, this))
    };
    i.Defaults = {video: !1, videoHeight: !1, videoWidth: !1}, i.prototype.fetch = function (t, e) {
        var i = t.attr("data-vimeo-id") ? "vimeo" : t.attr("data-vzaar-id") ? "vzaar" : "youtube",
            s = t.attr("data-vimeo-id") || t.attr("data-youtube-id") || t.attr("data-vzaar-id"),
            o = t.attr("data-width") || this._core.settings.videoWidth,
            n = t.attr("data-height") || this._core.settings.videoHeight, r = t.attr("href");
        if (!r) throw new Error("Missing video URL.");
        if (-1 < (s = r.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu")) i = "youtube"; else if (-1 < s[3].indexOf("vimeo")) i = "vimeo"; else {
            if (!(-1 < s[3].indexOf("vzaar"))) throw new Error("Video URL not supported.");
            i = "vzaar"
        }
        s = s[6], this._videos[r] = {
            type: i,
            id: s,
            width: o,
            height: n
        }, e.attr("data-video", r), this.thumbnail(t, this._videos[r])
    }, i.prototype.thumbnail = function (e, t) {
        function i(t) {
            s = c.lazyLoad ? d("<div/>", {class: "owl-video-tn " + l, srcType: t}) : d("<div/>", {
                class: "owl-video-tn",
                style: "opacity:1;background-image:url(" + t + ")"
            }), e.after(s), e.after('<div class="owl-video-play-icon"></div>')
        }

        var s, o, n = t.width && t.height ? "width:" + t.width + "px;height:" + t.height + "px;" : "",
            r = e.find("img"), a = "src", l = "", c = this._core.settings;
        if (e.wrap(d("<div/>", {
            class: "owl-video-wrapper",
            style: n
        })), this._core.settings.lazyLoad && (a = "data-src", l = "owl-lazy"), r.length) return i(r.attr(a)), r.remove(), !1;
        "youtube" === t.type ? (o = "//img.youtube.com/vi/" + t.id + "/hqdefault.jpg", i(o)) : "vimeo" === t.type ? d.ajax({
            type: "GET",
            url: "//vimeo.com/api/v2/video/" + t.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function (t) {
                o = t[0].thumbnail_large, i(o)
            }
        }) : "vzaar" === t.type && d.ajax({
            type: "GET",
            url: "//vzaar.com/api/videos/" + t.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function (t) {
                o = t.framegrab_url, i(o)
            }
        })
    }, i.prototype.stop = function () {
        this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video")
    }, i.prototype.play = function (t) {
        var e = d(t.target).closest("." + this._core.settings.itemClass), i = this._videos[e.attr("data-video")],
            s = i.width || "100%", o = i.height || this._core.$stage.height();
        this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), e = this._core.items(this._core.relative(e.index())), this._core.reset(e.index()), (t = d('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height", o), t.attr("width", s), "youtube" === i.type ? t.attr("src", "//www.youtube.com/embed/" + i.id + "?autoplay=1&rel=0&v=" + i.id) : "vimeo" === i.type ? t.attr("src", "//player.vimeo.com/video/" + i.id + "?autoplay=1") : "vzaar" === i.type && t.attr("src", "//view.vzaar.com/" + i.id + "/player?autoplay=true"), d(t).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")), this._playing = e.addClass("owl-video-playing"))
    }, i.prototype.isInFullScreen = function () {
        var t = e.fullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement;
        return t && d(t).parent().hasClass("owl-video-frame")
    }, i.prototype.destroy = function () {
        var t, e;
        for (t in this._core.$element.off("click.owl.video"), this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, d.fn.owlCarousel.Constructor.Plugins.Video = i
}(window.Zepto || window.jQuery, (window, document)), function (r) {
    var e = function (t) {
        this.core = t, this.core.options = r.extend({}, e.Defaults, this.core.options), this.swapping = !0, this.previous = void 0, this.next = void 0, this.handlers = {
            "change.owl.carousel": r.proxy(function (t) {
                t.namespace && "position" == t.property.name && (this.previous = this.core.current(), this.next = t.property.value)
            }, this), "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": r.proxy(function (t) {
                t.namespace && (this.swapping = "translated" == t.type)
            }, this), "translate.owl.carousel": r.proxy(function (t) {
                t.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
            }, this)
        }, this.core.$element.on(this.handlers)
    };
    e.Defaults = {animateOut: !1, animateIn: !1}, e.prototype.swap = function () {
        var t, e, i, s, o, n;
        1 === this.core.settings.items && r.support.animation && r.support.transition && (this.core.speed(0), e = r.proxy(this.clear, this), i = this.core.$stage.children().eq(this.previous), s = this.core.$stage.children().eq(this.next), o = this.core.settings.animateIn, n = this.core.settings.animateOut, this.core.current() !== this.previous && (n && (t = this.core.coordinates(this.previous) - this.core.coordinates(this.next), i.one(r.support.animation.end, e).css({left: t + "px"}).addClass("animated owl-animated-out").addClass(n)), o && s.one(r.support.animation.end, e).addClass("animated owl-animated-in").addClass(o)))
    }, e.prototype.clear = function (t) {
        r(t.target).css({left: ""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd()
    }, e.prototype.destroy = function () {
        var t, e;
        for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, r.fn.owlCarousel.Constructor.Plugins.Animate = e
}(window.Zepto || window.jQuery, (window, document)), function (s, o, e) {
    var i = function (t) {
        this._core = t, this._call = null, this._time = 0, this._timeout = 0, this._paused = !0, this._handlers = {
            "changed.owl.carousel": s.proxy(function (t) {
                t.namespace && "settings" === t.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : t.namespace && "position" === t.property.name && this._paused && (this._time = 0)
            }, this), "initialized.owl.carousel": s.proxy(function (t) {
                t.namespace && this._core.settings.autoplay && this.play()
            }, this), "play.owl.autoplay": s.proxy(function (t, e, i) {
                t.namespace && this.play(e, i)
            }, this), "stop.owl.autoplay": s.proxy(function (t) {
                t.namespace && this.stop()
            }, this), "mouseover.owl.autoplay": s.proxy(function () {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this), "mouseleave.owl.autoplay": s.proxy(function () {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
            }, this), "touchstart.owl.core": s.proxy(function () {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this), "touchend.owl.core": s.proxy(function () {
                this._core.settings.autoplayHoverPause && this.play()
            }, this)
        }, this._core.$element.on(this._handlers), this._core.options = s.extend({}, i.Defaults, this._core.options)
    };
    i.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1
    }, i.prototype._next = function (t) {
        this._call = o.setTimeout(s.proxy(this._next, this, t), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()), this._core.is("interacting") || e.hidden || this._core.next(t || this._core.settings.autoplaySpeed)
    }, i.prototype.read = function () {
        return (new Date).getTime() - this._time
    }, i.prototype.play = function (t, e) {
        var i;
        this._core.is("rotating") || this._core.enter("rotating"), t = t || this._core.settings.autoplayTimeout, i = Math.min(this._time % (this._timeout || t), t), this._paused ? (this._time = this.read(), this._paused = !1) : o.clearTimeout(this._call), this._time += this.read() % t - i, this._timeout = t, this._call = o.setTimeout(s.proxy(this._next, this, e), t - i)
    }, i.prototype.stop = function () {
        this._core.is("rotating") && (this._time = 0, this._paused = !0, o.clearTimeout(this._call), this._core.leave("rotating"))
    }, i.prototype.pause = function () {
        this._core.is("rotating") && !this._paused && (this._time = this.read(), this._paused = !0, o.clearTimeout(this._call))
    }, i.prototype.destroy = function () {
        var t, e;
        for (t in this.stop(), this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, s.fn.owlCarousel.Constructor.Plugins.autoplay = i
}(window.Zepto || window.jQuery, window, document), function (o) {
    "use strict";
    var e = function (t) {
        this._core = t, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
            next: this._core.next,
            prev: this._core.prev,
            to: this._core.to
        }, this._handlers = {
            "prepared.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + o(t.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
            }, this), "added.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 0, this._templates.pop())
            }, this), "remove.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 1)
            }, this), "changed.owl.carousel": o.proxy(function (t) {
                t.namespace && "position" == t.property.name && this.draw()
            }, this), "initialized.owl.carousel": o.proxy(function (t) {
                t.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"))
            }, this), "refreshed.owl.carousel": o.proxy(function (t) {
                t.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"))
            }, this)
        }, this._core.options = o.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers)
    };
    e.Defaults = {
        nav: !1,
        navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
        navSpeed: !1,
        navElement: 'button type="button" role="presentation"',
        navContainer: !1,
        navContainerClass: "owl-nav",
        navClass: ["owl-prev", "owl-next"],
        slideBy: 1,
        dotClass: "owl-dot",
        dotsClass: "owl-dots",
        dots: !0,
        dotsEach: !1,
        dotsData: !1,
        dotsSpeed: !1,
        dotsContainer: !1
    }, e.prototype.initialize = function () {
        var t, i = this._core.settings;
        for (t in this._controls.$relative = (i.navContainer ? o(i.navContainer) : o("<div>").addClass(i.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = o("<" + i.navElement + ">").addClass(i.navClass[0]).html(i.navText[0]).prependTo(this._controls.$relative).on("click", o.proxy(function (t) {
            this.prev(i.navSpeed)
        }, this)), this._controls.$next = o("<" + i.navElement + ">").addClass(i.navClass[1]).html(i.navText[1]).appendTo(this._controls.$relative).on("click", o.proxy(function (t) {
            this.next(i.navSpeed)
        }, this)), i.dotsData || (this._templates = [o('<button role="button">').addClass(i.dotClass).append(o("<span>")).prop("outerHTML")]), this._controls.$absolute = (i.dotsContainer ? o(i.dotsContainer) : o("<div>").addClass(i.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "button", o.proxy(function (t) {
            var e = (o(t.target).parent().is(this._controls.$absolute) ? o(t.target) : o(t.target).parent()).index();
            t.preventDefault(), this.to(e, i.dotsSpeed)
        }, this)), this._overrides) this._core[t] = o.proxy(this[t], this)
    }, e.prototype.destroy = function () {
        var t, e, i, s, o = this._core.settings;
        for (t in this._handlers) this.$element.off(t, this._handlers[t]);
        for (e in this._controls) "$relative" === e && o.navContainer ? this._controls[e].html("") : this._controls[e].remove();
        for (s in this.overides) this._core[s] = this._overrides[s];
        for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
    }, e.prototype.update = function () {
        var t, e, i = this._core.clones().length / 2, s = i + this._core.items().length, o = this._core.maximum(!0),
            n = this._core.settings, r = n.center || n.autoWidth || n.dotsData ? 1 : n.dotsEach || n.items;
        if ("page" !== n.slideBy && (n.slideBy = Math.min(n.slideBy, n.items)), n.dots || "page" == n.slideBy) for (this._pages = [], t = i, e = 0; t < s; t++) {
            if (r <= e || 0 === e) {
                if (this._pages.push({start: Math.min(o, t - i), end: t - i + r - 1}), Math.min(o, t - i) === o) break;
                e = 0, 0
            }
            e += this._core.mergers(this._core.relative(t))
        }
    }, e.prototype.draw = function () {
        var t = this._core.settings, e = this._core.items().length <= t.items,
            i = this._core.relative(this._core.current()), s = t.loop || t.rewind;
        this._controls.$relative.toggleClass("disabled", !t.nav || e), t.nav && (this._controls.$previous.toggleClass("disabled", !s && i <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !s && i >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !t.dots || e), t.dots && (e = this._pages.length - this._controls.$absolute.children().length, t.dotsData && 0 != e ? this._controls.$absolute.html(this._templates.join("")) : 0 < e ? this._controls.$absolute.append(new Array(1 + e).join(this._templates[0])) : e < 0 && this._controls.$absolute.children().slice(e).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(o.inArray(this.current(), this._pages)).addClass("active"))
    }, e.prototype.onTrigger = function (t) {
        var e = this._core.settings;
        t.page = {
            index: o.inArray(this.current(), this._pages),
            count: this._pages.length,
            size: e && (e.center || e.autoWidth || e.dotsData ? 1 : e.dotsEach || e.items)
        }
    }, e.prototype.current = function () {
        var i = this._core.relative(this._core.current());
        return o.grep(this._pages, o.proxy(function (t, e) {
            return t.start <= i && t.end >= i
        }, this)).pop()
    }, e.prototype.getPosition = function (t) {
        var e, i, s = this._core.settings;
        return "page" == s.slideBy ? (e = o.inArray(this.current(), this._pages), i = this._pages.length, t ? ++e : --e, e = this._pages[(e % i + i) % i].start) : (e = this._core.relative(this._core.current()), i = this._core.items().length, t ? e += s.slideBy : e -= s.slideBy), e
    }, e.prototype.next = function (t) {
        o.proxy(this._overrides.to, this._core)(this.getPosition(!0), t)
    }, e.prototype.prev = function (t) {
        o.proxy(this._overrides.to, this._core)(this.getPosition(!1), t)
    }, e.prototype.to = function (t, e, i) {
        !i && this._pages.length ? (i = this._pages.length, o.proxy(this._overrides.to, this._core)(this._pages[(t % i + i) % i].start, e)) : o.proxy(this._overrides.to, this._core)(t, e)
    }, o.fn.owlCarousel.Constructor.Plugins.Navigation = e
}(window.Zepto || window.jQuery, (window, document)), function (s, o) {
    "use strict";
    var e = function (t) {
        this._core = t, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
            "initialized.owl.carousel": s.proxy(function (t) {
                t.namespace && "URLHash" === this._core.settings.startPosition && s(o).trigger("hashchange.owl.navigation")
            }, this), "prepared.owl.carousel": s.proxy(function (t) {
                var e;
                !t.namespace || (e = s(t.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash")) && (this._hashes[e] = t.content)
            }, this), "changed.owl.carousel": s.proxy(function (t) {
                var i;
                t.namespace && "position" === t.property.name && (i = this._core.items(this._core.relative(this._core.current())), (t = s.map(this._hashes, function (t, e) {
                    return t === i ? e : null
                }).join()) && o.location.hash.slice(1) !== t && (o.location.hash = t))
            }, this)
        }, this._core.options = s.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers), s(o).on("hashchange.owl.navigation", s.proxy(function (t) {
            var e = o.location.hash.substring(1), i = this._core.$stage.children(),
                e = this._hashes[e] && i.index(this._hashes[e]);
            void 0 !== e && e !== this._core.current() && this._core.to(this._core.relative(e), !1, !0)
        }, this))
    };
    e.Defaults = {URLhashListener: !1}, e.prototype.destroy = function () {
        var t, e;
        for (t in s(o).off("hashchange.owl.navigation"), this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, s.fn.owlCarousel.Constructor.Plugins.Hash = e
}(window.Zepto || window.jQuery, window, document), function (o, n) {
    var r = o("<support>").get(0).style, a = "Webkit Moz O ms".split(" "), t = {
        transition: {
            end: {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd",
                transition: "transitionend"
            }
        },
        animation: {
            end: {
                WebkitAnimation: "webkitAnimationEnd",
                MozAnimation: "animationend",
                OAnimation: "oAnimationEnd",
                animation: "animationend"
            }
        }
    }, e = function () {
        return !!l("transform")
    }, i = function () {
        return !!l("perspective")
    }, s = function () {
        return !!l("animation")
    };

    function l(t, i) {
        var s = !1, e = t.charAt(0).toUpperCase() + t.slice(1);
        return o.each((t + " " + a.join(e + " ") + e).split(" "), function (t, e) {
            if (r[e] !== n) return s = !i || e, !1
        }), s
    }

    function c(t) {
        return l(t, !0)
    }

    !function () {
        return !!l("transition")
    }() || (o.support.transition = new String(c("transition")), o.support.transition.end = t.transition.end[o.support.transition]), s() && (o.support.animation = new String(c("animation")), o.support.animation.end = t.animation.end[o.support.animation]), e() && (o.support.transform = new String(c("transform")), o.support.transform3d = i())
}(window.Zepto || window.jQuery, (window, void document)), function (i) {
    "use strict";
    i.fn.counterUp = function (t) {
        var e = i.extend({time: 400, delay: 10}, t);
        return this.each(function () {
            var l = i(this), c = e;
            l.waypoint(function () {
                for (var t = [], e = c.time / c.delay, i = l.text(), s = /[0-9]+,[0-9]+/.test(i), i = i.replace(/,/g, ""), o = (/^[0-9]+$/.test(i), /^[0-9]+\.[0-9]+$/.test(i)), n = o ? (i.split(".")[1] || []).length : 0, r = e; 1 <= r; r--) {
                    var a = parseInt(i / e * r);
                    if (o && (a = parseFloat(i / e * r).toFixed(n)), s) for (; /(\d+)(\d{3})/.test(a.toString());) a = a.toString().replace(/(\d+)(\d{3})/, "$1,$2");
                    t.unshift(a)
                }
                l.data("counterup-nums", t), l.text("0");
                l.data("counterup-func", function () {
                    l.text(l.data("counterup-nums").shift()), l.data("counterup-nums").length ? setTimeout(l.data("counterup-func"), c.delay) : (l.data("counterup-nums"), l.data("counterup-nums", null), l.data("counterup-func", null))
                }), setTimeout(l.data("counterup-func"), c.delay), this.destroy()
            }, {offset: "100%"})
        })
    }
}(jQuery), function (g, o, t, f) {
    var s = "stellar", i = {
            scrollProperty: "scroll",
            positionProperty: "position",
            horizontalScrolling: !0,
            verticalScrolling: !0,
            horizontalOffset: 0,
            verticalOffset: 0,
            responsive: !1,
            parallaxBackgrounds: !0,
            parallaxElements: !0,
            hideDistantElements: !0,
            hideElement: function (t) {
                t.hide()
            },
            showElement: function (t) {
                t.show()
            }
        }, a = {
            scroll: {
                getLeft: function (t) {
                    return t.scrollLeft()
                }, setLeft: function (t, e) {
                    t.scrollLeft(e)
                }, getTop: function (t) {
                    return t.scrollTop()
                }, setTop: function (t, e) {
                    t.scrollTop(e)
                }
            }, position: {
                getLeft: function (t) {
                    return -1 * parseInt(t.css("left"), 10)
                }, getTop: function (t) {
                    return -1 * parseInt(t.css("top"), 10)
                }
            }, margin: {
                getLeft: function (t) {
                    return -1 * parseInt(t.css("margin-left"), 10)
                }, getTop: function (t) {
                    return -1 * parseInt(t.css("margin-top"), 10)
                }
            }, transform: {
                getLeft: function (t) {
                    t = getComputedStyle(t[0])[n];
                    return "none" !== t ? -1 * parseInt(t.match(/(-?[0-9]+)/g)[4], 10) : 0
                }, getTop: function (t) {
                    t = getComputedStyle(t[0])[n];
                    return "none" !== t ? -1 * parseInt(t.match(/(-?[0-9]+)/g)[5], 10) : 0
                }
            }
        }, l = {
            position: {
                setLeft: function (t, e) {
                    t.css("left", e)
                }, setTop: function (t, e) {
                    t.css("top", e)
                }
            }, transform: {
                setPosition: function (t, e, i, s, o) {
                    t[0].style[n] = "translate3d(" + (e - i) + "px, " + (s - o) + "px, 0)"
                }
            }
        }, n = function () {
            var t, e = /^(Moz|Webkit|Khtml|O|ms|Icab)(?=[A-Z])/, i = g("script")[0].style, s = "";
            for (t in i) if (e.test(t)) {
                s = t.match(e)[0];
                break
            }
            return "WebkitOpacity" in i && (s = "Webkit"), "KhtmlOpacity" in i && (s = "Khtml"), function (t) {
                return s + (0 < s.length ? t.charAt(0).toUpperCase() + t.slice(1) : t)
            }
        }()("transform"), e = g("<div />", {style: "background:#fff"}).css("background-position-x") !== f,
        m = e ? function (t, e, i) {
            t.css({"background-position-x": e, "background-position-y": i})
        } : function (t, e, i) {
            t.css("background-position", e + " " + i)
        }, v = e ? function (t) {
            return [t.css("background-position-x"), t.css("background-position-y")]
        } : function (t) {
            return t.css("background-position").split(" ")
        },
        r = o.requestAnimationFrame || o.webkitRequestAnimationFrame || o.mozRequestAnimationFrame || o.oRequestAnimationFrame || o.msRequestAnimationFrame || function (t) {
            setTimeout(t, 1e3 / 60)
        };

    function c(t, e) {
        this.element = t, this.options = g.extend({}, i, e), this._defaults = i, this._name = s, this.init()
    }

    c.prototype = {
        init: function () {
            this.options.name = s + "_" + Math.floor(1e9 * Math.random()), this._defineElements(), this._defineGetters(), this._defineSetters(), this._handleWindowLoadAndResize(), this._detectViewport(), this.refresh({firstLoad: !0}), "scroll" === this.options.scrollProperty ? this._handleScrollEvent() : this._startAnimationLoop()
        }, _defineElements: function () {
            this.element === t.body && (this.element = o), this.$scrollElement = g(this.element), this.$element = this.element === o ? g("body") : this.$scrollElement, this.$viewportElement = this.options.viewportElement !== f ? g(this.options.viewportElement) : this.$scrollElement[0] === o || "scroll" === this.options.scrollProperty ? this.$scrollElement : this.$scrollElement.parent()
        }, _defineGetters: function () {
            var t = this, e = a[t.options.scrollProperty];
            this._getScrollLeft = function () {
                return e.getLeft(t.$scrollElement)
            }, this._getScrollTop = function () {
                return e.getTop(t.$scrollElement)
            }
        }, _defineSetters: function () {
            var n = this, t = a[n.options.scrollProperty], r = l[n.options.positionProperty], e = t.setLeft,
                i = t.setTop;
            this._setScrollLeft = "function" == typeof e ? function (t) {
                e(n.$scrollElement, t)
            } : g.noop, this._setScrollTop = "function" == typeof i ? function (t) {
                i(n.$scrollElement, t)
            } : g.noop, this._setPosition = r.setPosition || function (t, e, i, s, o) {
                n.options.horizontalScrolling && r.setLeft(t, e, i), n.options.verticalScrolling && r.setTop(t, s, o)
            }
        }, _handleWindowLoadAndResize: function () {
            var t = this, e = g(o);
            t.options.responsive && e.bind("load." + this.name, function () {
                t.refresh()
            }), e.bind("resize." + this.name, function () {
                t._detectViewport(), t.options.responsive && t.refresh()
            })
        }, refresh: function (t) {
            var i = this, e = i._getScrollLeft(), s = i._getScrollTop();
            t && t.firstLoad || this._reset(), this._setScrollLeft(0), this._setScrollTop(0), this._setOffsets(), this._findParticles(), this._findBackgrounds(), t && t.firstLoad && /WebKit/.test(navigator.userAgent) && g(o).on("load", function () {
                var t = i._getScrollLeft(), e = i._getScrollTop();
                i._setScrollLeft(t + 1), i._setScrollTop(e + 1), i._setScrollLeft(t), i._setScrollTop(e)
            }), this._setScrollLeft(e), this._setScrollTop(s)
        }, _detectViewport: function () {
            var t = {left: this.$viewportElement.scrollLeft(), top: this.$viewportElement.scrollTop()},
                e = null !== t && t !== f;
            this.viewportWidth = this.$viewportElement.width(), this.viewportHeight = this.$viewportElement.height(), this.viewportOffsetTop = e ? t.top : 0, this.viewportOffsetLeft = e ? t.left : 0
        }, _findParticles: function () {
            var p = this;
            this._getScrollLeft(), this._getScrollTop();
            if (this.particles !== f) for (var t = this.particles.length - 1; 0 <= t; t--) this.particles[t].$element.data("stellar-elementIsActive", f);
            this.particles = [], this.options.parallaxElements && this.$element.find("[data-stellar-ratio]").each(function (t) {
                var e, i, s, o, n, r, a, l = g(this), c = 0, d = 0, h = 0, u = 0;
                if (l.data("stellar-elementIsActive")) {
                    if (l.data("stellar-elementIsActive") !== this) return
                } else l.data("stellar-elementIsActive", this);
                p.options.showElement(l), l.data("stellar-startingLeft") ? (l.css("left", l.data("stellar-startingLeft")), l.css("top", l.data("stellar-startingTop"))) : (l.data("stellar-startingLeft", l.css("left")), l.data("stellar-startingTop", l.css("top"))), e = l.position().left, i = l.position().top, s = "auto" === l.css("margin-left") ? 0 : parseInt(l.css("margin-left"), 10), o = "auto" === l.css("margin-top") ? 0 : parseInt(l.css("margin-top"), 10), r = l.offset().left - s, a = l.offset().top - o, l.parents().each(function () {
                    var t = g(this);
                    if (!0 === t.data("stellar-offset-parent")) return c = h, d = u, n = t, !1;
                    h += t.position().left, u += t.position().top
                }), s = l.data("stellar-horizontal-offset") !== f ? l.data("stellar-horizontal-offset") : n !== f && n.data("stellar-horizontal-offset") !== f ? n.data("stellar-horizontal-offset") : p.horizontalOffset, o = l.data("stellar-vertical-offset") !== f ? l.data("stellar-vertical-offset") : n !== f && n.data("stellar-vertical-offset") !== f ? n.data("stellar-vertical-offset") : p.verticalOffset, p.particles.push({
                    $element: l,
                    $offsetParent: n,
                    isFixed: "fixed" === l.css("position"),
                    horizontalOffset: s,
                    verticalOffset: o,
                    startingPositionLeft: e,
                    startingPositionTop: i,
                    startingOffsetLeft: r,
                    startingOffsetTop: a,
                    parentOffsetLeft: c,
                    parentOffsetTop: d,
                    stellarRatio: l.data("stellar-ratio") !== f ? l.data("stellar-ratio") : 1,
                    width: l.outerWidth(!0),
                    height: l.outerHeight(!0),
                    isHidden: !1
                })
            })
        }, _findBackgrounds: function () {
            var t, h = this, u = this._getScrollLeft(), p = this._getScrollTop();
            this.backgrounds = [], this.options.parallaxBackgrounds && (t = this.$element.find("[data-stellar-background-ratio]"), this.$element.data("stellar-background-ratio") && (t = t.add(this.$element)), t.each(function () {
                var t, e, i, s, o, n = g(this), r = v(n), a = 0, l = 0, c = 0, d = 0;
                if (n.data("stellar-backgroundIsActive")) {
                    if (n.data("stellar-backgroundIsActive") !== this) return
                } else n.data("stellar-backgroundIsActive", this);
                n.data("stellar-backgroundStartingLeft") ? m(n, n.data("stellar-backgroundStartingLeft"), n.data("stellar-backgroundStartingTop")) : (n.data("stellar-backgroundStartingLeft", r[0]), n.data("stellar-backgroundStartingTop", r[1])), t = "auto" === n.css("margin-left") ? 0 : parseInt(n.css("margin-left"), 10), e = "auto" === n.css("margin-top") ? 0 : parseInt(n.css("margin-top"), 10), i = n.offset().left - t - u, s = n.offset().top - e - p, n.parents().each(function () {
                    var t = g(this);
                    if (!0 === t.data("stellar-offset-parent")) return a = c, l = d, o = t, !1;
                    c += t.position().left, d += t.position().top
                }), t = n.data("stellar-horizontal-offset") !== f ? n.data("stellar-horizontal-offset") : o !== f && o.data("stellar-horizontal-offset") !== f ? o.data("stellar-horizontal-offset") : h.horizontalOffset, e = n.data("stellar-vertical-offset") !== f ? n.data("stellar-vertical-offset") : o !== f && o.data("stellar-vertical-offset") !== f ? o.data("stellar-vertical-offset") : h.verticalOffset, h.backgrounds.push({
                    $element: n,
                    $offsetParent: o,
                    isFixed: "fixed" === n.css("background-attachment"),
                    horizontalOffset: t,
                    verticalOffset: e,
                    startingValueLeft: r[0],
                    startingValueTop: r[1],
                    startingBackgroundPositionLeft: isNaN(parseInt(r[0], 10)) ? 0 : parseInt(r[0], 10),
                    startingBackgroundPositionTop: isNaN(parseInt(r[1], 10)) ? 0 : parseInt(r[1], 10),
                    startingPositionLeft: n.position().left,
                    startingPositionTop: n.position().top,
                    startingOffsetLeft: i,
                    startingOffsetTop: s,
                    parentOffsetLeft: a,
                    parentOffsetTop: l,
                    stellarRatio: n.data("stellar-background-ratio") === f ? 1 : n.data("stellar-background-ratio")
                })
            }))
        }, _reset: function () {
            for (var t, e, i, s, o = this.particles.length - 1; 0 <= o; o--) e = (t = this.particles[o]).$element.data("stellar-startingLeft"), i = t.$element.data("stellar-startingTop"), this._setPosition(t.$element, e, e, i, i), this.options.showElement(t.$element), t.$element.data("stellar-startingLeft", null).data("stellar-elementIsActive", null).data("stellar-backgroundIsActive", null);
            for (o = this.backgrounds.length - 1; 0 <= o; o--) (s = this.backgrounds[o]).$element.data("stellar-backgroundStartingLeft", null).data("stellar-backgroundStartingTop", null), m(s.$element, s.startingValueLeft, s.startingValueTop)
        }, destroy: function () {
            this._reset(), this.$scrollElement.unbind("resize." + this.name).unbind("scroll." + this.name), this._animationLoop = g.noop, g(o).unbind("load." + this.name).unbind("resize." + this.name)
        }, _setOffsets: function () {
            var t = this, e = g(o);
            e.unbind("resize.horizontal-" + this.name).unbind("resize.vertical-" + this.name), "function" == typeof this.options.horizontalOffset ? (this.horizontalOffset = this.options.horizontalOffset(), e.bind("resize.horizontal-" + this.name, function () {
                t.horizontalOffset = t.options.horizontalOffset()
            })) : this.horizontalOffset = this.options.horizontalOffset, "function" == typeof this.options.verticalOffset ? (this.verticalOffset = this.options.verticalOffset(), e.bind("resize.vertical-" + this.name, function () {
                t.verticalOffset = t.options.verticalOffset()
            })) : this.verticalOffset = this.options.verticalOffset
        }, _repositionElements: function () {
            var t, e, i, s, o, n, r, a, l, c, d = this._getScrollLeft(), h = this._getScrollTop(), u = !0, p = !0;
            if (this.currentScrollLeft !== d || this.currentScrollTop !== h || this.currentWidth !== this.viewportWidth || this.currentHeight !== this.viewportHeight) {
                for (this.currentScrollLeft = d, this.currentScrollTop = h, this.currentWidth = this.viewportWidth, this.currentHeight = this.viewportHeight, c = this.particles.length - 1; 0 <= c; c--) e = (t = this.particles[c]).isFixed ? 1 : 0, a = this.options.horizontalScrolling ? (n = (d + t.horizontalOffset + this.viewportOffsetLeft + t.startingPositionLeft - t.startingOffsetLeft + t.parentOffsetLeft) * -(t.stellarRatio + e - 1) + t.startingPositionLeft) - t.startingPositionLeft + t.startingOffsetLeft : (n = t.startingPositionLeft, t.startingOffsetLeft), l = this.options.verticalScrolling ? (r = (h + t.verticalOffset + this.viewportOffsetTop + t.startingPositionTop - t.startingOffsetTop + t.parentOffsetTop) * -(t.stellarRatio + e - 1) + t.startingPositionTop) - t.startingPositionTop + t.startingOffsetTop : (r = t.startingPositionTop, t.startingOffsetTop), this.options.hideDistantElements && (p = !this.options.horizontalScrolling || a + t.width > (t.isFixed ? 0 : d) && a < (t.isFixed ? 0 : d) + this.viewportWidth + this.viewportOffsetLeft, u = !this.options.verticalScrolling || l + t.height > (t.isFixed ? 0 : h) && l < (t.isFixed ? 0 : h) + this.viewportHeight + this.viewportOffsetTop), p && u ? (t.isHidden && (this.options.showElement(t.$element), t.isHidden = !1), this._setPosition(t.$element, n, t.startingPositionLeft, r, t.startingPositionTop)) : t.isHidden || (this.options.hideElement(t.$element), t.isHidden = !0);
                for (c = this.backgrounds.length - 1; 0 <= c; c--) e = (i = this.backgrounds[c]).isFixed ? 0 : 1, s = this.options.horizontalScrolling ? (d + i.horizontalOffset - this.viewportOffsetLeft - i.startingOffsetLeft + i.parentOffsetLeft - i.startingBackgroundPositionLeft) * (e - i.stellarRatio) + "px" : i.startingValueLeft, o = this.options.verticalScrolling ? (h + i.verticalOffset - this.viewportOffsetTop - i.startingOffsetTop + i.parentOffsetTop - i.startingBackgroundPositionTop) * (e - i.stellarRatio) + "px" : i.startingValueTop, m(i.$element, s, o)
            }
        }, _handleScrollEvent: function () {
            function t() {
                i._repositionElements(), s = !1
            }

            function e() {
                s || (r(t), s = !0)
            }

            var i = this, s = !1;
            this.$scrollElement.bind("scroll." + this.name, e), e()
        }, _startAnimationLoop: function () {
            var t = this;
            this._animationLoop = function () {
                r(t._animationLoop), t._repositionElements()
            }, this._animationLoop()
        }
    }, g.fn[s] = function (e) {
        var i = arguments;
        return e === f || "object" == typeof e ? this.each(function () {
            g.data(this, "plugin_" + s) || g.data(this, "plugin_" + s, new c(this, e))
        }) : "string" == typeof e && "_" !== e[0] && "init" !== e ? this.each(function () {
            var t = g.data(this, "plugin_" + s);
            t instanceof c && "function" == typeof t[e] && t[e].apply(t, Array.prototype.slice.call(i, 1)), "destroy" === e && g.data(this, "plugin_" + s, null)
        }) : void 0
    }, g[s] = function (t) {
        var e = g(o);
        return e.stellar.apply(e, Array.prototype.slice.call(arguments, 0))
    }, g[s].scrollProperty = a, g[s].positionProperty = l, o.Stellar = c
}(jQuery, this, document), function () {
    "use strict";

    function e(t) {
        if (!t) throw new Error("No options passed to Waypoint constructor");
        if (!t.element) throw new Error("No element option passed to Waypoint constructor");
        if (!t.handler) throw new Error("No handler option passed to Waypoint constructor");
        this.key = "waypoint-" + i, this.options = e.Adapter.extend({}, e.defaults, t), this.element = this.options.element, this.adapter = new e.Adapter(this.element), this.callback = t.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = e.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis
        }), this.context = e.Context.findOrCreateByElement(this.options.context), e.offsetAliases[this.options.offset] && (this.options.offset = e.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), n[this.key] = this, i += 1
    }

    var i = 0, n = {};
    e.prototype.queueTrigger = function (t) {
        this.group.queueTrigger(this, t)
    }, e.prototype.trigger = function (t) {
        this.enabled && this.callback && this.callback.apply(this, t)
    }, e.prototype.destroy = function () {
        this.context.remove(this), this.group.remove(this), delete n[this.key]
    }, e.prototype.disable = function () {
        return this.enabled = !1, this
    }, e.prototype.enable = function () {
        return this.context.refresh(), this.enabled = !0, this
    }, e.prototype.next = function () {
        return this.group.next(this)
    }, e.prototype.previous = function () {
        return this.group.previous(this)
    }, e.invokeAll = function (t) {
        var e, i = [];
        for (e in n) i.push(n[e]);
        for (var s = 0, o = i.length; s < o; s++) i[s][t]()
    }, e.destroyAll = function () {
        e.invokeAll("destroy")
    }, e.disableAll = function () {
        e.invokeAll("disable")
    }, e.enableAll = function () {
        for (var t in e.Context.refreshAll(), n) n[t].enabled = !0;
        return this
    }, e.refreshAll = function () {
        e.Context.refreshAll()
    }, e.viewportHeight = function () {
        return window.innerHeight || document.documentElement.clientHeight
    }, e.viewportWidth = function () {
        return document.documentElement.clientWidth
    }, e.adapters = [], e.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0
    }, e.offsetAliases = {
        "bottom-in-view": function () {
            return this.context.innerHeight() - this.adapter.outerHeight()
        }, "right-in-view": function () {
            return this.context.innerWidth() - this.adapter.outerWidth()
        }
    }, window.Waypoint = e
}(), function () {
    "use strict";

    function e(t) {
        window.setTimeout(t, 1e3 / 60)
    }

    function i(t) {
        this.element = t, this.Adapter = p.Adapter, this.adapter = new this.Adapter(t), this.key = "waypoint-context-" + s, this.didScroll = !1, this.didResize = !1, this.oldScroll = {
            x: this.adapter.scrollLeft(),
            y: this.adapter.scrollTop()
        }, this.waypoints = {
            vertical: {},
            horizontal: {}
        }, t.waypointContextKey = this.key, o[t.waypointContextKey] = this, s += 1, p.windowContext || (p.windowContext = !0, p.windowContext = new i(window)), this.createThrottledScrollHandler(), this.createThrottledResizeHandler()
    }

    var s = 0, o = {}, p = window.Waypoint, t = window.onload;
    i.prototype.add = function (t) {
        var e = t.options.horizontal ? "horizontal" : "vertical";
        this.waypoints[e][t.key] = t, this.refresh()
    }, i.prototype.checkEmpty = function () {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
            e = this.Adapter.isEmptyObject(this.waypoints.vertical), i = this.element == this.element.window;
        t && e && !i && (this.adapter.off(".waypoints"), delete o[this.key])
    }, i.prototype.createThrottledResizeHandler = function () {
        function t() {
            e.handleResize(), e.didResize = !1
        }

        var e = this;
        this.adapter.on("resize.waypoints", function () {
            e.didResize || (e.didResize = !0, p.requestAnimationFrame(t))
        })
    }, i.prototype.createThrottledScrollHandler = function () {
        function t() {
            e.handleScroll(), e.didScroll = !1
        }

        var e = this;
        this.adapter.on("scroll.waypoints", function () {
            e.didScroll && !p.isTouch || (e.didScroll = !0, p.requestAnimationFrame(t))
        })
    }, i.prototype.handleResize = function () {
        p.Context.refreshAll()
    }, i.prototype.handleScroll = function () {
        var t, e, i = {}, s = {
            horizontal: {
                newScroll: this.adapter.scrollLeft(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left"
            },
            vertical: {
                newScroll: this.adapter.scrollTop(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up"
            }
        };
        for (t in s) {
            var o, n = s[t], r = n.newScroll > n.oldScroll ? n.forward : n.backward;
            for (o in this.waypoints[t]) {
                var a, l, c = this.waypoints[t][o];
                null !== c.triggerPoint && (a = n.oldScroll < c.triggerPoint, l = n.newScroll >= c.triggerPoint, (a && l || !a && !l) && (c.queueTrigger(r), i[c.group.id] = c.group))
            }
        }
        for (e in i) i[e].flushTriggers();
        this.oldScroll = {x: s.horizontal.newScroll, y: s.vertical.newScroll}
    }, i.prototype.innerHeight = function () {
        return this.element == this.element.window ? p.viewportHeight() : this.adapter.innerHeight()
    }, i.prototype.remove = function (t) {
        delete this.waypoints[t.axis][t.key], this.checkEmpty()
    }, i.prototype.innerWidth = function () {
        return this.element == this.element.window ? p.viewportWidth() : this.adapter.innerWidth()
    }, i.prototype.destroy = function () {
        var t, e = [];
        for (t in this.waypoints) for (var i in this.waypoints[t]) e.push(this.waypoints[t][i]);
        for (var s = 0, o = e.length; s < o; s++) e[s].destroy()
    }, i.prototype.refresh = function () {
        var t, e, i = this.element == this.element.window, s = i ? void 0 : this.adapter.offset(), o = {};
        for (e in this.handleScroll(), t = {
            horizontal: {
                contextOffset: i ? 0 : s.left,
                contextScroll: i ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left",
                offsetProp: "left"
            },
            vertical: {
                contextOffset: i ? 0 : s.top,
                contextScroll: i ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up",
                offsetProp: "top"
            }
        }) {
            var n, r = t[e];
            for (n in this.waypoints[e]) {
                var a, l = this.waypoints[e][n], c = l.options.offset, d = l.triggerPoint, h = 0, u = null == d;
                l.element !== l.element.window && (h = l.adapter.offset()[r.offsetProp]), "function" == typeof c ? c = c.apply(l) : "string" == typeof c && (c = parseFloat(c), -1 < l.options.offset.indexOf("%") && (c = Math.ceil(r.contextDimension * c / 100))), a = r.contextScroll - r.contextOffset, l.triggerPoint = Math.floor(h + a - c), a = d < r.oldScroll, c = l.triggerPoint >= r.oldScroll, d = !a && !c, !u && (a && c) ? (l.queueTrigger(r.backward), o[l.group.id] = l.group) : (!u && d || u && r.oldScroll >= l.triggerPoint) && (l.queueTrigger(r.forward), o[l.group.id] = l.group)
            }
        }
        return p.requestAnimationFrame(function () {
            for (var t in o) o[t].flushTriggers()
        }), this
    }, i.findOrCreateByElement = function (t) {
        return i.findByElement(t) || new i(t)
    }, i.refreshAll = function () {
        for (var t in o) o[t].refresh()
    }, i.findByElement = function (t) {
        return o[t.waypointContextKey]
    }, window.onload = function () {
        t && t(), i.refreshAll()
    }, p.requestAnimationFrame = function (t) {
        (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || e).call(window, t)
    }, p.Context = i
}(), function () {
    "use strict";

    function r(t, e) {
        return t.triggerPoint - e.triggerPoint
    }

    function a(t, e) {
        return e.triggerPoint - t.triggerPoint
    }

    function e(t) {
        this.name = t.name, this.axis = t.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), i[this.axis][this.name] = this
    }

    var i = {vertical: {}, horizontal: {}}, s = window.Waypoint;
    e.prototype.add = function (t) {
        this.waypoints.push(t)
    }, e.prototype.clearTriggerQueues = function () {
        this.triggerQueues = {up: [], down: [], left: [], right: []}
    }, e.prototype.flushTriggers = function () {
        for (var t in this.triggerQueues) {
            var e = this.triggerQueues[t], i = "up" === t || "left" === t;
            e.sort(i ? a : r);
            for (var s = 0, o = e.length; s < o; s += 1) {
                var n = e[s];
                !n.options.continuous && s !== e.length - 1 || n.trigger([t])
            }
        }
        this.clearTriggerQueues()
    }, e.prototype.next = function (t) {
        this.waypoints.sort(r);
        t = s.Adapter.inArray(t, this.waypoints);
        return t === this.waypoints.length - 1 ? null : this.waypoints[t + 1]
    }, e.prototype.previous = function (t) {
        this.waypoints.sort(r);
        t = s.Adapter.inArray(t, this.waypoints);
        return t ? this.waypoints[t - 1] : null
    }, e.prototype.queueTrigger = function (t, e) {
        this.triggerQueues[e].push(t)
    }, e.prototype.remove = function (t) {
        t = s.Adapter.inArray(t, this.waypoints);
        -1 < t && this.waypoints.splice(t, 1)
    }, e.prototype.first = function () {
        return this.waypoints[0]
    }, e.prototype.last = function () {
        return this.waypoints[this.waypoints.length - 1]
    }, e.findOrCreate = function (t) {
        return i[t.axis][t.name] || new e(t)
    }, s.Group = e
}(), function () {
    "use strict";

    function i(t) {
        this.$element = s(t)
    }

    var s = window.jQuery, t = window.Waypoint;
    s.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function (t, e) {
        i.prototype[e] = function () {
            var t = Array.prototype.slice.call(arguments);
            return this.$element[e].apply(this.$element, t)
        }
    }), s.each(["extend", "inArray", "isEmptyObject"], function (t, e) {
        i[e] = s[e]
    }), t.adapters.push({name: "jquery", Adapter: i}), t.Adapter = i
}(), function () {
    "use strict";

    function t(s) {
        return function () {
            var e = [], i = arguments[0];
            return s.isFunction(arguments[0]) && ((i = s.extend({}, arguments[1])).handler = arguments[0]), this.each(function () {
                var t = s.extend({}, i, {element: this});
                "string" == typeof t.context && (t.context = s(this).closest(t.context)[0]), e.push(new o(t))
            }), e
        }
    }

    var o = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto))
}(), function (c) {
    "use strict";
    c.fn.countdown = function (t, n) {
        var r = c(this), a = {date: null, format: null};

        function e() {
            var t = Date.parse(a.date) / 1e3, e = Math.floor(c.now() / 1e3);
            t <= e && (n.call(this), clearInterval(l));
            var i = t - e, s = Math.floor(i / 86400);
            i -= 60 * s * 60 * 24;
            var o = Math.floor(i / 3600);
            i -= 60 * o * 60;
            e = Math.floor(i / 60);
            i -= 60 * e, 1 == s ? r.find(".timeRefDays").text("day") : r.find(".timeRefDays").text("days"), 1 == o ? r.find(".timeRefHours").text("hour") : r.find(".timeRefHours").text("hours"), 1 == e ? r.find(".timeRefMinutes").text("minute") : r.find(".timeRefMinutes").text("minutes"), 1 == i ? r.find(".timeRefSeconds").text("second") : r.find(".timeRefSeconds").text("seconds"), "on" == a.format && (s = 2 <= String(s).length ? s : "0" + s, o = 2 <= String(o).length ? o : "0" + o, e = 2 <= String(e).length ? e : "0" + e, i = 2 <= String(i).length ? i : "0" + i), isNaN(t) ? (alert("Invalid date. Here's an example: 12 Tuesday 2012 17:30:00"), clearInterval(l)) : (r.find(".days").text(s), r.find(".hours").text(o), r.find(".minutes").text(e), r.find(".seconds").text(i))
        }

        t && c.extend(a, t), e();
        var l = setInterval(e, 1e3)
    }
}(jQuery), function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : t("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
}(function (c) {
    function t() {
    }

    function d(t, e) {
        g.ev.on("mfp" + t + w, e)
    }

    function h(t, e, i, s) {
        var o = document.createElement("div");
        return o.className = "mfp-" + t, i && (o.innerHTML = i), s ? e && e.appendChild(o) : (o = c(o), e && o.appendTo(e)), o
    }

    function u(t, e) {
        g.ev.triggerHandler("mfp" + t, e), g.st.callbacks && (t = t.charAt(0).toLowerCase() + t.slice(1), g.st.callbacks[t] && g.st.callbacks[t].apply(g, c.isArray(e) ? e : [e]))
    }

    function p(t) {
        return t === e && g.currTemplate.closeBtn || (g.currTemplate.closeBtn = c(g.st.closeMarkup.replace("%title%", g.st.tClose)), e = t), g.currTemplate.closeBtn
    }

    function n() {
        c.magnificPopup.instance || ((g = new t).init(), c.magnificPopup.instance = g)
    }

    var g, s, f, o, m, e, l = "Close", v = "BeforeClose", y = "MarkupParse", b = "Open", w = ".mfp", x = "mfp-ready",
        i = "mfp-removing", r = "mfp-prevent-close", a = !!window.jQuery, _ = c(window);
    t.prototype = {
        constructor: t, init: function () {
            var t = navigator.appVersion;
            g.isLowIE = g.isIE8 = document.all && !document.addEventListener, g.isAndroid = /android/gi.test(t), g.isIOS = /iphone|ipad|ipod/gi.test(t), g.supportsTransition = function () {
                var t = document.createElement("p").style, e = ["ms", "O", "Moz", "Webkit"];
                if (void 0 !== t.transition) return !0;
                for (; e.length;) if (e.pop() + "Transition" in t) return !0;
                return !1
            }(), g.probablyMobile = g.isAndroid || g.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), f = c(document), g.popupsCache = {}
        }, open: function (t) {
            if (!1 === t.isObj) {
                g.items = t.items.toArray(), g.index = 0;
                for (var e, i = t.items, s = 0; s < i.length; s++) if ((e = i[s]).parsed && (e = e.el[0]), e === t.el[0]) {
                    g.index = s;
                    break
                }
            } else g.items = c.isArray(t.items) ? t.items : [t.items], g.index = t.index || 0;
            if (!g.isOpen) {
                g.types = [], m = "", t.mainEl && t.mainEl.length ? g.ev = t.mainEl.eq(0) : g.ev = f, t.key ? (g.popupsCache[t.key] || (g.popupsCache[t.key] = {}), g.currTemplate = g.popupsCache[t.key]) : g.currTemplate = {}, g.st = c.extend(!0, {}, c.magnificPopup.defaults, t), g.fixedContentPos = "auto" === g.st.fixedContentPos ? !g.probablyMobile : g.st.fixedContentPos, g.st.modal && (g.st.closeOnContentClick = !1, g.st.closeOnBgClick = !1, g.st.showCloseBtn = !1, g.st.enableEscapeKey = !1), g.bgOverlay || (g.bgOverlay = h("bg").on("click" + w, function () {
                    g.close()
                }), g.wrap = h("wrap").attr("tabindex", -1).on("click" + w, function (t) {
                    g._checkIfClose(t.target) && g.close()
                }), g.container = h("container", g.wrap)), g.contentContainer = h("content"), g.st.preloader && (g.preloader = h("preloader", g.container, g.st.tLoading));
                var o = c.magnificPopup.modules;
                for (s = 0; s < o.length; s++) {
                    var n = (n = o[s]).charAt(0).toUpperCase() + n.slice(1);
                    g["init" + n].call(g)
                }
                u("BeforeOpen"), g.st.showCloseBtn && (g.st.closeBtnInside ? (d(y, function (t, e, i, s) {
                    i.close_replaceWith = p(s.type)
                }), m += " mfp-close-btn-in") : g.wrap.append(p())), g.st.alignTop && (m += " mfp-align-top"), g.fixedContentPos ? g.wrap.css({
                    overflow: g.st.overflowY,
                    overflowX: "hidden",
                    overflowY: g.st.overflowY
                }) : g.wrap.css({
                    top: _.scrollTop(),
                    position: "absolute"
                }), !1 !== g.st.fixedBgPos && ("auto" !== g.st.fixedBgPos || g.fixedContentPos) || g.bgOverlay.css({
                    height: f.height(),
                    position: "absolute"
                }), g.st.enableEscapeKey && f.on("keyup" + w, function (t) {
                    27 === t.keyCode && g.close()
                }), _.on("resize" + w, function () {
                    g.updateSize()
                }), g.st.closeOnContentClick || (m += " mfp-auto-cursor"), m && g.wrap.addClass(m);
                var r = g.wH = _.height(), a = {};
                g.fixedContentPos && g._hasScrollBar(r) && ((l = g._getScrollbarSize()) && (a.marginRight = l)), g.fixedContentPos && (g.isIE7 ? c("body, html").css("overflow", "hidden") : a.overflow = "hidden");
                var l = g.st.mainClass;
                return g.isIE7 && (l += " mfp-ie7"), l && g._addClassToMFP(l), g.updateItemHTML(), u("BuildControls"), c("html").css(a), g.bgOverlay.add(g.wrap).prependTo(g.st.prependTo || c(document.body)), g._lastFocusedEl = document.activeElement, setTimeout(function () {
                    g.content ? (g._addClassToMFP(x), g._setFocus()) : g.bgOverlay.addClass(x), f.on("focusin" + w, g._onFocusIn)
                }, 16), g.isOpen = !0, g.updateSize(r), u(b), t
            }
            g.updateItemHTML()
        }, close: function () {
            g.isOpen && (u(v), g.isOpen = !1, g.st.removalDelay && !g.isLowIE && g.supportsTransition ? (g._addClassToMFP(i), setTimeout(function () {
                g._close()
            }, g.st.removalDelay)) : g._close())
        }, _close: function () {
            u(l);
            var t = i + " " + x + " ";
            g.bgOverlay.detach(), g.wrap.detach(), g.container.empty(), g.st.mainClass && (t += g.st.mainClass + " "), g._removeClassFromMFP(t), g.fixedContentPos && (t = {marginRight: ""}, g.isIE7 ? c("body, html").css("overflow", "") : t.overflow = "", c("html").css(t)), f.off("keyup.mfp focusin" + w), g.ev.off(w), g.wrap.attr("class", "mfp-wrap").removeAttr("style"), g.bgOverlay.attr("class", "mfp-bg"), g.container.attr("class", "mfp-container"), !g.st.showCloseBtn || g.st.closeBtnInside && !0 !== g.currTemplate[g.currItem.type] || g.currTemplate.closeBtn && g.currTemplate.closeBtn.detach(), g.st.autoFocusLast && g._lastFocusedEl && c(g._lastFocusedEl).focus(), g.currItem = null, g.content = null, g.currTemplate = null, g.prevHeight = 0, u("AfterClose")
        }, updateSize: function (t) {
            var e;
            g.isIOS ? (e = document.documentElement.clientWidth / window.innerWidth, e = window.innerHeight * e, g.wrap.css("height", e), g.wH = e) : g.wH = t || _.height(), g.fixedContentPos || g.wrap.css("height", g.wH), u("Resize")
        }, updateItemHTML: function () {
            var t = g.items[g.index];
            g.contentContainer.detach(), g.content && g.content.detach(), t.parsed || (t = g.parseEl(g.index));
            var e = t.type;
            u("BeforeChange", [g.currItem ? g.currItem.type : "", e]), g.currItem = t, g.currTemplate[e] || (i = !!g.st[e] && g.st[e].markup, u("FirstMarkupParse", i), g.currTemplate[e] = !i || c(i)), o && o !== t.type && g.container.removeClass("mfp-" + o + "-holder");
            var i = g["get" + e.charAt(0).toUpperCase() + e.slice(1)](t, g.currTemplate[e]);
            g.appendContent(i, e), t.preloaded = !0, u("Change", t), o = t.type, g.container.prepend(g.contentContainer), u("AfterChange")
        }, appendContent: function (t, e) {
            (g.content = t) ? g.st.showCloseBtn && g.st.closeBtnInside && !0 === g.currTemplate[e] ? g.content.find(".mfp-close").length || g.content.append(p()) : g.content = t : g.content = "", u("BeforeAppend"), g.container.addClass("mfp-" + e + "-holder"), g.contentContainer.append(g.content)
        }, parseEl: function (t) {
            var e, i = g.items[t];
            if ((i = i.tagName ? {el: c(i)} : (e = i.type, {data: i, src: i.src})).el) {
                for (var s = g.types, o = 0; o < s.length; o++) if (i.el.hasClass("mfp-" + s[o])) {
                    e = s[o];
                    break
                }
                i.src = i.el.attr("data-mfp-src"), i.src || (i.src = i.el.attr("href"))
            }
            return i.type = e || g.st.type || "inline", i.index = t, i.parsed = !0, g.items[t] = i, u("ElementParse", i), g.items[t]
        }, addGroup: function (e, i) {
            function t(t) {
                t.mfpEl = this, g._openClick(t, e, i)
            }

            var s = "click.magnificPopup";
            (i = i || {}).mainEl = e, i.items ? (i.isObj = !0, e.off(s).on(s, t)) : (i.isObj = !1, i.delegate ? e.off(s).on(s, i.delegate, t) : (i.items = e).off(s).on(s, t))
        }, _openClick: function (t, e, i) {
            if ((void 0 !== i.midClick ? i : c.magnificPopup.defaults).midClick || !(2 === t.which || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey)) {
                var s = (void 0 !== i.disableOn ? i : c.magnificPopup.defaults).disableOn;
                if (s) if (c.isFunction(s)) {
                    if (!s.call(g)) return !0
                } else if (_.width() < s) return !0;
                t.type && (t.preventDefault(), g.isOpen && t.stopPropagation()), i.el = c(t.mfpEl), i.delegate && (i.items = e.find(i.delegate)), g.open(i)
            }
        }, updateStatus: function (t, e) {
            var i;
            g.preloader && (s !== t && g.container.removeClass("mfp-s-" + s), e || "loading" !== t || (e = g.st.tLoading), u("UpdateStatus", i = {
                status: t,
                text: e
            }), t = i.status, e = i.text, g.preloader.html(e), g.preloader.find("a").on("click", function (t) {
                t.stopImmediatePropagation()
            }), g.container.addClass("mfp-s-" + t), s = t)
        }, _checkIfClose: function (t) {
            if (!c(t).hasClass(r)) {
                var e = g.st.closeOnContentClick, i = g.st.closeOnBgClick;
                if (e && i) return !0;
                if (!g.content || c(t).hasClass("mfp-close") || g.preloader && t === g.preloader[0]) return !0;
                if (t === g.content[0] || c.contains(g.content[0], t)) {
                    if (e) return !0
                } else if (i && c.contains(document, t)) return !0;
                return !1
            }
        }, _addClassToMFP: function (t) {
            g.bgOverlay.addClass(t), g.wrap.addClass(t)
        }, _removeClassFromMFP: function (t) {
            this.bgOverlay.removeClass(t), g.wrap.removeClass(t)
        }, _hasScrollBar: function (t) {
            return (g.isIE7 ? f.height() : document.body.scrollHeight) > (t || _.height())
        }, _setFocus: function () {
            (g.st.focus ? g.content.find(g.st.focus).eq(0) : g.wrap).focus()
        }, _onFocusIn: function (t) {
            return t.target === g.wrap[0] || c.contains(g.wrap[0], t.target) ? void 0 : (g._setFocus(), !1)
        }, _parseMarkup: function (o, t, e) {
            var n;
            e.data && (t = c.extend(e.data, t)), u(y, [o, t, e]), c.each(t, function (t, e) {
                return void 0 === e || !1 === e || void (1 < (n = t.split("_")).length ? 0 < (i = o.find(w + "-" + n[0])).length && ("replaceWith" === (s = n[1]) ? i[0] !== e[0] && i.replaceWith(e) : "img" === s ? i.is("img") ? i.attr("src", e) : i.replaceWith(c("<img>").attr("src", e).attr("class", i.attr("class"))) : i.attr(n[1], e)) : o.find(w + "-" + t).html(e));
                var i, s
            })
        }, _getScrollbarSize: function () {
            var t;
            return void 0 === g.scrollbarSize && ((t = document.createElement("div")).style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(t), g.scrollbarSize = t.offsetWidth - t.clientWidth, document.body.removeChild(t)), g.scrollbarSize
        }
    }, c.magnificPopup = {
        instance: null,
        proto: t.prototype,
        modules: [],
        open: function (t, e) {
            return n(), (t = t ? c.extend(!0, {}, t) : {}).isObj = !0, t.index = e || 0, this.instance.open(t)
        },
        close: function () {
            return c.magnificPopup.instance && c.magnificPopup.instance.close()
        },
        registerModule: function (t, e) {
            e.options && (c.magnificPopup.defaults[t] = e.options), c.extend(this.proto, e.proto), this.modules.push(t)
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading...",
            autoFocusLast: !0
        }
    }, c.fn.magnificPopup = function (t) {
        n();
        var e, i, s, o = c(this);
        return "string" == typeof t ? "open" === t ? (e = a ? o.data("magnificPopup") : o[0].magnificPopup, i = parseInt(arguments[1], 10) || 0, s = e.items ? e.items[i] : (s = o, e.delegate && (s = s.find(e.delegate)), s.eq(i)), g._openClick({mfpEl: s}, o, e)) : g.isOpen && g[t].apply(g, Array.prototype.slice.call(arguments, 1)) : (t = c.extend(!0, {}, t), a ? o.data("magnificPopup", t) : o[0].magnificPopup = t, g.addGroup(o, t)), o
    };

    function C() {
        S && (T.after(S.addClass($)).detach(), S = null)
    }

    var $, T, S, k = "inline";
    c.magnificPopup.registerModule(k, {
        options: {hiddenClass: "hide", markup: "", tNotFound: "Content not found"},
        proto: {
            initInline: function () {
                g.types.push(k), d(l + "." + k, function () {
                    C()
                })
            }, getInline: function (t, e) {
                if (C(), t.src) {
                    var i, s = g.st.inline, o = c(t.src);
                    return o.length ? ((i = o[0].parentNode) && i.tagName && (T || ($ = s.hiddenClass, T = h($), $ = "mfp-" + $), S = o.after(T).detach().removeClass($)), g.updateStatus("ready")) : (g.updateStatus("error", s.tNotFound), o = c("<div>")), t.inlineElement = o
                }
                return g.updateStatus("ready"), g._parseMarkup(e, {}, t), e
            }
        }
    });

    function z() {
        O && c(document.body).removeClass(O)
    }

    function E() {
        z(), g.req && g.req.abort()
    }

    var O, P = "ajax";
    c.magnificPopup.registerModule(P, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        }, proto: {
            initAjax: function () {
                g.types.push(P), O = g.st.ajax.cursor, d(l + "." + P, E), d("BeforeChange." + P, E)
            }, getAjax: function (s) {
                O && c(document.body).addClass(O), g.updateStatus("loading");
                var t = c.extend({
                    url: s.src, success: function (t, e, i) {
                        i = {data: t, xhr: i};
                        u("ParseAjax", i), g.appendContent(c(i.data), P), s.finished = !0, z(), g._setFocus(), setTimeout(function () {
                            g.wrap.addClass(x)
                        }, 16), g.updateStatus("ready"), u("AjaxContentAdded")
                    }, error: function () {
                        z(), s.finished = s.loadError = !0, g.updateStatus("error", g.st.ajax.tError.replace("%url%", s.src))
                    }
                }, g.st.ajax.settings);
                return g.req = c.ajax(t), ""
            }
        }
    });
    var I;
    c.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        }, proto: {
            initImage: function () {
                var t = g.st.image, e = ".image";
                g.types.push("image"), d(b + e, function () {
                    "image" === g.currItem.type && t.cursor && c(document.body).addClass(t.cursor)
                }), d(l + e, function () {
                    t.cursor && c(document.body).removeClass(t.cursor), _.off("resize" + w)
                }), d("Resize" + e, g.resizeImage), g.isLowIE && d("AfterChange", g.resizeImage)
            }, resizeImage: function () {
                var t, e = g.currItem;
                e && e.img && g.st.image.verticalFit && (t = 0, g.isLowIE && (t = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)), e.img.css("max-height", g.wH - t))
            }, _onImageHasSize: function (t) {
                t.img && (t.hasSize = !0, I && clearInterval(I), t.isCheckingImgSize = !1, u("ImageHasSize", t), t.imgHidden && (g.content && g.content.removeClass("mfp-loading"), t.imgHidden = !1))
            }, findImageSize: function (e) {
                var i = 0, s = e.img[0], o = function (t) {
                    I && clearInterval(I), I = setInterval(function () {
                        return 0 < s.naturalWidth ? void g._onImageHasSize(e) : (200 < i && clearInterval(I), void (3 === ++i ? o(10) : 40 === i ? o(50) : 100 === i && o(500)))
                    }, t)
                };
                o(1)
            }, getImage: function (t, e) {
                var i, s = 0, o = function () {
                    t && (t.img[0].complete ? (t.img.off(".mfploader"), t === g.currItem && (g._onImageHasSize(t), g.updateStatus("ready")), t.hasSize = !0, t.loaded = !0, u("ImageLoadComplete")) : ++s < 200 ? setTimeout(o, 100) : n())
                }, n = function () {
                    t && (t.img.off(".mfploader"), t === g.currItem && (g._onImageHasSize(t), g.updateStatus("error", r.tError.replace("%url%", t.src))), t.hasSize = !0, t.loaded = !0, t.loadError = !0)
                }, r = g.st.image, a = e.find(".mfp-img");
                return a.length && ((i = document.createElement("img")).className = "mfp-img", t.el && t.el.find("img").length && (i.alt = t.el.find("img").attr("alt")), t.img = c(i).on("load.mfploader", o).on("error.mfploader", n), i.src = t.src, a.is("img") && (t.img = t.img.clone()), 0 < (i = t.img[0]).naturalWidth ? t.hasSize = !0 : i.width || (t.hasSize = !1)), g._parseMarkup(e, {
                    title: function (t) {
                        if (t.data && void 0 !== t.data.title) return t.data.title;
                        var e = g.st.image.titleSrc;
                        if (e) {
                            if (c.isFunction(e)) return e.call(g, t);
                            if (t.el) return t.el.attr(e) || ""
                        }
                        return ""
                    }(t), img_replaceWith: t.img
                }, t), g.resizeImage(), t.hasSize ? (I && clearInterval(I), t.loadError ? (e.addClass("mfp-loading"), g.updateStatus("error", r.tError.replace("%url%", t.src))) : (e.removeClass("mfp-loading"), g.updateStatus("ready"))) : (g.updateStatus("loading"), t.loading = !0, t.hasSize || (t.imgHidden = !0, e.addClass("mfp-loading"), g.findImageSize(t))), e
            }
        }
    });
    var A;
    c.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1, easing: "ease-in-out", duration: 300, opener: function (t) {
                return t.is("img") ? t : t.find("img")
            }
        }, proto: {
            initZoom: function () {
                var t, e, i, s, o, n, r = g.st.zoom, a = ".zoom";
                r.enabled && g.supportsTransition && (s = r.duration, o = function (t) {
                    var e = t.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                        i = "all " + r.duration / 1e3 + "s " + r.easing,
                        s = {position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden"},
                        t = "transition";
                    return s["-webkit-" + t] = s["-moz-" + t] = s["-o-" + t] = s[t] = i, e.css(s), e
                }, n = function () {
                    g.content.css("visibility", "visible")
                }, d("BuildControls" + a, function () {
                    g._allowZoom() && (clearTimeout(e), g.content.css("visibility", "hidden"), (t = g._getItemToZoom()) ? ((i = o(t)).css(g._getOffset()), g.wrap.append(i), e = setTimeout(function () {
                        i.css(g._getOffset(!0)), e = setTimeout(function () {
                            n(), setTimeout(function () {
                                i.remove(), t = i = null, u("ZoomAnimationEnded")
                            }, 16)
                        }, s)
                    }, 16)) : n())
                }), d(v + a, function () {
                    if (g._allowZoom()) {
                        if (clearTimeout(e), g.st.removalDelay = s, !t) {
                            if (!(t = g._getItemToZoom())) return;
                            i = o(t)
                        }
                        i.css(g._getOffset(!0)), g.wrap.append(i), g.content.css("visibility", "hidden"), setTimeout(function () {
                            i.css(g._getOffset())
                        }, 16)
                    }
                }), d(l + a, function () {
                    g._allowZoom() && (n(), i && i.remove(), t = null)
                }))
            }, _allowZoom: function () {
                return "image" === g.currItem.type
            }, _getItemToZoom: function () {
                return !!g.currItem.hasSize && g.currItem.img
            }, _getOffset: function (t) {
                var e = t ? g.currItem.img : g.st.zoom.opener(g.currItem.el || g.currItem), i = e.offset(),
                    s = parseInt(e.css("padding-top"), 10), t = parseInt(e.css("padding-bottom"), 10);
                i.top -= c(window).scrollTop() - s;
                s = {width: e.width(), height: (a ? e.innerHeight() : e[0].offsetHeight) - t - s};
                return void 0 === A && (A = void 0 !== document.createElement("p").style.MozTransform), A ? s["-moz-transform"] = s.transform = "translate(" + i.left + "px," + i.top + "px)" : (s.left = i.left, s.top = i.top), s
            }
        }
    });

    function M(t) {
        var e;
        !g.currTemplate[L] || (e = g.currTemplate[L].find("iframe")).length && (t || (e[0].src = "//about:blank"), g.isIE8 && e.css("display", t ? "block" : "none"))
    }

    var L = "iframe";
    c.magnificPopup.registerModule(L, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: {index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1"},
                vimeo: {index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1"},
                gmaps: {index: "//maps.google.", src: "%id%&output=embed"}
            }
        }, proto: {
            initIframe: function () {
                g.types.push(L), d("BeforeChange", function (t, e, i) {
                    e !== i && (e === L ? M() : i === L && M(!0))
                }), d(l + "." + L, function () {
                    M()
                })
            }, getIframe: function (t, e) {
                var i = t.src, s = g.st.iframe;
                c.each(s.patterns, function () {
                    return -1 < i.indexOf(this.index) ? (this.id && (i = "string" == typeof this.id ? i.substr(i.lastIndexOf(this.id) + this.id.length, i.length) : this.id.call(this, i)), i = this.src.replace("%id%", i), !1) : void 0
                });
                var o = {};
                return s.srcAction && (o[s.srcAction] = i), g._parseMarkup(e, o, t), g.updateStatus("ready"), e
            }
        }
    });

    function j(t) {
        var e = g.items.length;
        return e - 1 < t ? t - e : t < 0 ? e + t : t
    }

    function q(t, e, i) {
        return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i)
    }

    c.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        }, proto: {
            initGallery: function () {
                var n = g.st.gallery, t = ".mfp-gallery";
                return g.direction = !0, !(!n || !n.enabled) && (m += " mfp-gallery", d(b + t, function () {
                    n.navigateByImgClick && g.wrap.on("click" + t, ".mfp-img", function () {
                        return 1 < g.items.length ? (g.next(), !1) : void 0
                    }), f.on("keydown" + t, function (t) {
                        37 === t.keyCode ? g.prev() : 39 === t.keyCode && g.next()
                    })
                }), d("UpdateStatus" + t, function (t, e) {
                    e.text && (e.text = q(e.text, g.currItem.index, g.items.length))
                }), d(y + t, function (t, e, i, s) {
                    var o = g.items.length;
                    i.counter = 1 < o ? q(n.tCounter, s.index, o) : ""
                }), d("BuildControls" + t, function () {
                    var t, e;
                    1 < g.items.length && n.arrows && !g.arrowLeft && (e = n.arrowMarkup, t = g.arrowLeft = c(e.replace(/%title%/gi, n.tPrev).replace(/%dir%/gi, "left")).addClass(r), e = g.arrowRight = c(e.replace(/%title%/gi, n.tNext).replace(/%dir%/gi, "right")).addClass(r), t.click(function () {
                        g.prev()
                    }), e.click(function () {
                        g.next()
                    }), g.container.append(t.add(e)))
                }), d("Change" + t, function () {
                    g._preloadTimeout && clearTimeout(g._preloadTimeout), g._preloadTimeout = setTimeout(function () {
                        g.preloadNearbyImages(), g._preloadTimeout = null
                    }, 16)
                }), void d(l + t, function () {
                    f.off(t), g.wrap.off("click" + t), g.arrowRight = g.arrowLeft = null
                }))
            }, next: function () {
                g.direction = !0, g.index = j(g.index + 1), g.updateItemHTML()
            }, prev: function () {
                g.direction = !1, g.index = j(g.index - 1), g.updateItemHTML()
            }, goTo: function (t) {
                g.direction = t >= g.index, g.index = t, g.updateItemHTML()
            }, preloadNearbyImages: function () {
                for (var t = g.st.gallery.preload, e = Math.min(t[0], g.items.length), i = Math.min(t[1], g.items.length), s = 1; s <= (g.direction ? i : e); s++) g._preloadItem(g.index + s);
                for (s = 1; s <= (g.direction ? e : i); s++) g._preloadItem(g.index - s)
            }, _preloadItem: function (t) {
                var e;
                t = j(t), g.items[t].preloaded || ((e = g.items[t]).parsed || (e = g.parseEl(t)), u("LazyLoad", e), "image" === e.type && (e.img = c('<img class="mfp-img" />').on("load.mfploader", function () {
                    e.hasSize = !0
                }).on("error.mfploader", function () {
                    e.hasSize = !0, e.loadError = !0, u("LazyLoadError", e)
                }).attr("src", e.src)), e.preloaded = !0)
            }
        }
    });
    var D = "retina";
    c.magnificPopup.registerModule(D, {
        options: {
            replaceSrc: function (t) {
                return t.src.replace(/\.\w+$/, function (t) {
                    return "@2x" + t
                })
            }, ratio: 1
        }, proto: {
            initRetina: function () {
                var i, s;
                1 < window.devicePixelRatio && (i = g.st.retina, s = i.ratio, 1 < (s = isNaN(s) ? s() : s) && (d("ImageHasSize." + D, function (t, e) {
                    e.img.css({"max-width": e.img[0].naturalWidth / s, width: "100%"})
                }), d("ElementParse." + D, function (t, e) {
                    e.src = i.replaceSrc(e, s)
                })))
            }
        }
    }), n()
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (g) {
    !function () {
        "use strict";
        var i = {
            mode: "lg-slide",
            cssEasing: "ease",
            easing: "linear",
            speed: 600,
            height: "100%",
            width: "100%",
            addClass: "",
            startClass: "lg-start-zoom",
            backdropDuration: 150,
            hideBarsDelay: 6e3,
            useLeft: !1,
            ariaLabelledby: "",
            ariaDescribedby: "",
            closable: !0,
            loop: !0,
            escKey: !0,
            keyPress: !0,
            controls: !0,
            slideEndAnimatoin: !0,
            hideControlOnEnd: !1,
            mousewheel: !0,
            getCaptionFromTitleOrAlt: !0,
            appendSubHtmlTo: ".lg-sub-html",
            subHtmlSelectorRelative: !1,
            preload: 1,
            showAfterLoad: !0,
            selector: "",
            selectWithin: "",
            nextHtml: "",
            prevHtml: "",
            index: !1,
            iframeMaxWidth: "100%",
            download: !0,
            counter: !0,
            appendCounterTo: ".lg-toolbar",
            swipeThreshold: 50,
            enableSwipe: !0,
            enableDrag: !0,
            dynamic: !1,
            dynamicEl: [],
            galleryId: 1,
            supportLegacyBrowser: !0
        };

        function e(t, e) {
            if (this.el = t, this.$el = g(t), this.s = g.extend({}, i, e), this.s.dynamic && "undefined" !== this.s.dynamicEl && this.s.dynamicEl.constructor === Array && !this.s.dynamicEl.length) throw "When using dynamic mode, you must also define dynamicEl as an Array.";
            return this.modules = {}, this.lGalleryOn = !1, this.lgBusy = !1, this.hideBarTimeout = !1, this.isTouch = "ontouchstart" in document.documentElement, this.s.slideEndAnimatoin && (this.s.hideControlOnEnd = !1), this.s.dynamic ? this.$items = this.s.dynamicEl : "this" === this.s.selector ? this.$items = this.$el : "" !== this.s.selector ? this.s.selectWithin ? this.$items = g(this.s.selectWithin).find(this.s.selector) : this.$items = this.$el.find(g(this.s.selector)) : this.$items = this.$el.children(), this.$slide = "", this.$outer = "", this.init(), this
        }

        e.prototype.init = function () {
            var t = this;
            t.s.preload > t.$items.length && (t.s.preload = t.$items.length);
            var e = window.location.hash;
            0 < e.indexOf("lg=" + this.s.galleryId) && (t.index = parseInt(e.split("&slide=")[1], 10), g("body").addClass("lg-from-hash"), g("body").hasClass("lg-on") || (setTimeout(function () {
                t.build(t.index)
            }), g("body").addClass("lg-on"))), t.s.dynamic ? (t.$el.trigger("onBeforeOpen.lg"), t.index = t.s.index || 0, g("body").hasClass("lg-on") || setTimeout(function () {
                t.build(t.index), g("body").addClass("lg-on")
            })) : t.$items.on("click.lgcustom", function (e) {
                try {
                    e.preventDefault(), e.preventDefault()
                } catch (t) {
                    e.returnValue = !1
                }
                t.$el.trigger("onBeforeOpen.lg"), t.index = t.s.index || t.$items.index(this), g("body").hasClass("lg-on") || (t.build(t.index), g("body").addClass("lg-on"))
            })
        }, e.prototype.build = function (t) {
            var e = this;
            e.structure(), g.each(g.fn.lightGallery.modules, function (t) {
                e.modules[t] = new g.fn.lightGallery.modules[t](e.el)
            }), e.slide(t, !1, !1, !1), e.s.keyPress && e.keyPress(), 1 < e.$items.length ? (e.arrow(), setTimeout(function () {
                e.enableDrag(), e.enableSwipe()
            }, 50), e.s.mousewheel && e.mousewheel()) : e.$slide.on("click.lg", function () {
                e.$el.trigger("onSlideClick.lg")
            }), e.counter(), e.closeGallery(), e.$el.trigger("onAfterOpen.lg"), 0 < e.s.hideBarsDelay && e.$outer.on("mousemove.lg click.lg touchstart.lg", function () {
                e.$outer.removeClass("lg-hide-items"), clearTimeout(e.hideBarTimeout), e.hideBarTimeout = setTimeout(function () {
                    e.$outer.addClass("lg-hide-items")
                }, e.s.hideBarsDelay)
            }), e.$outer.trigger("mousemove.lg")
        }, e.prototype.structure = function () {
            var t = "", e = "", i = 0, s = "", o = this;
            for (g("body").append('<div class="lg-backdrop"></div>'), g(".lg-backdrop").css("transition-duration", this.s.backdropDuration + "ms"), i = 0; i < this.$items.length; i++) t += '<div class="lg-item"></div>';
            this.s.controls && 1 < this.$items.length && (e = '<div class="lg-actions"><button type="button" aria-label="Previous slide" class="lg-prev lg-icon">' + this.s.prevHtml + '</button><button type="button" aria-label="Next slide" class="lg-next lg-icon">' + this.s.nextHtml + "</button></div>"), ".lg-sub-html" === this.s.appendSubHtmlTo && (s = '<div role="status" aria-live="polite" class="lg-sub-html"></div>');
            var s = '<div tabindex="-1" aria-modal="true" ' + (this.s.ariaLabelledby ? 'aria-labelledby="' + this.s.ariaLabelledby + '"' : "") + " " + (this.s.ariaDescribedby ? 'aria-describedby="' + this.s.ariaDescribedby + '"' : "") + ' role="dialog" class="lg-outer ' + this.s.addClass + " " + this.s.startClass + '"><div class="lg" style="width:' + this.s.width + "; height:" + this.s.height + '"><div class="lg-inner">' + t + '</div><div class="lg-toolbar lg-group"><button type="button" aria-label="Close gallery" class="lg-close lg-icon"></button></div>' + e + s + "</div></div>";
            g("body").append(s), this.$outer = g(".lg-outer"), this.$outer.focus(), this.$slide = this.$outer.find(".lg-item"), this.s.useLeft ? (this.$outer.addClass("lg-use-left"), this.s.mode = "lg-slide") : this.$outer.addClass("lg-use-css3"), o.setTop(), g(window).on("resize.lg orientationchange.lg", function () {
                setTimeout(function () {
                    o.setTop()
                }, 100)
            }), this.$slide.eq(this.index).addClass("lg-current"), this.doCss() ? this.$outer.addClass("lg-css3") : (this.$outer.addClass("lg-css"), this.s.speed = 0), this.$outer.addClass(this.s.mode), this.s.enableDrag && 1 < this.$items.length && this.$outer.addClass("lg-grab"), this.s.showAfterLoad && this.$outer.addClass("lg-show-after-load"), this.doCss() && ((s = this.$outer.find(".lg-inner")).css("transition-timing-function", this.s.cssEasing), s.css("transition-duration", this.s.speed + "ms")), setTimeout(function () {
                g(".lg-backdrop").addClass("in")
            }), setTimeout(function () {
                o.$outer.addClass("lg-visible")
            }, this.s.backdropDuration), this.s.download && this.$outer.find(".lg-toolbar").append('<a id="lg-download" aria-label="Download" target="_blank" download class="lg-download lg-icon"></a>'), this.prevScrollTop = g(window).scrollTop()
        }, e.prototype.setTop = function () {
            var t, e, i;
            "100%" !== this.s.height && (e = ((t = g(window).height()) - parseInt(this.s.height, 10)) / 2, i = this.$outer.find(".lg"), t >= parseInt(this.s.height, 10) ? i.css("top", e + "px") : i.css("top", "0px"))
        }, e.prototype.doCss = function () {
            return !!function () {
                for (var t = ["transition", "MozTransition", "WebkitTransition", "OTransition", "msTransition", "KhtmlTransition"], e = document.documentElement, i = 0, i = 0; i < t.length; i++) if (t[i] in e.style) return !0
            }()
        }, e.prototype.isVideo = function (t, e) {
            var i = this.s.dynamic ? this.s.dynamicEl[e].html : this.$items.eq(e).attr("data-html");
            if (!t) return i ? {html5: !0} : (console.error("lightGallery :- data-src is not provided on slide item " + (e + 1) + ". Please make sure the selector property is properly configured. More info - http://sachinchoolur.github.io/lightGallery/demos/html-markup.html"), !1);
            var s = t.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)/i),
                i = t.match(/\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i),
                e = t.match(/\/\/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i),
                t = t.match(/\/\/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i);
            return s ? {youtube: s} : i ? {vimeo: i} : e ? {dailymotion: e} : t ? {vk: t} : void 0
        }, e.prototype.counter = function () {
            this.s.counter && g(this.s.appendCounterTo).append('<div id="lg-counter" role="status" aria-live="polite"><span id="lg-counter-current">' + (parseInt(this.index, 10) + 1) + '</span> / <span id="lg-counter-all">' + this.$items.length + "</span></div>")
        }, e.prototype.addHtml = function (t) {
            var e, i, s, o = null;
            this.s.dynamic ? this.s.dynamicEl[t].subHtmlUrl ? e = this.s.dynamicEl[t].subHtmlUrl : o = this.s.dynamicEl[t].subHtml : (i = this.$items.eq(t)).attr("data-sub-html-url") ? e = i.attr("data-sub-html-url") : (o = i.attr("data-sub-html"), this.s.getCaptionFromTitleOrAlt && !o && (o = i.attr("title") || i.find("img").first().attr("alt"))), e || (null != o ? "." !== (s = o.substring(0, 1)) && "#" !== s || (o = (this.s.subHtmlSelectorRelative && !this.s.dynamic ? i.find(o) : g(o)).html()) : o = ""), ".lg-sub-html" === this.s.appendSubHtmlTo ? e ? this.$outer.find(this.s.appendSubHtmlTo).load(e) : this.$outer.find(this.s.appendSubHtmlTo).html(o) : e ? this.$slide.eq(t).load(e) : this.$slide.eq(t).append(o), null != o && ("" === o ? this.$outer.find(this.s.appendSubHtmlTo).addClass("lg-empty-html") : this.$outer.find(this.s.appendSubHtmlTo).removeClass("lg-empty-html")), this.$el.trigger("onAfterAppendSubHtml.lg", [t])
        }, e.prototype.preload = function (t) {
            for (var e = 1, i = 1, e = 1; e <= this.s.preload && !(e >= this.$items.length - t); e++) this.loadContent(t + e, !1, 0);
            for (i = 1; i <= this.s.preload && !(t - i < 0); i++) this.loadContent(t - i, !1, 0)
        }, e.prototype.loadContent = function (e, t, i) {
            var s, a, o, n, r, l, c = this, d = !1, h = function (t) {
                    for (var e = [], i = [], s = 0; s < t.length; s++) {
                        var o = t[s].split(" ");
                        "" === o[0] && o.splice(0, 1), i.push(o[0]), e.push(o[1])
                    }
                    for (var n = g(window).width(), r = 0; r < e.length; r++) if (parseInt(e[r], 10) > n) {
                        a = i[r];
                        break
                    }
                },
                u = c.s.dynamic ? (c.s.dynamicEl[e].poster && (d = !0, o = c.s.dynamicEl[e].poster), r = c.s.dynamicEl[e].html, a = c.s.dynamicEl[e].src, l = c.s.dynamicEl[e].alt, c.s.dynamicEl[e].responsive && h(c.s.dynamicEl[e].responsive.split(",")), n = c.s.dynamicEl[e].srcset, c.s.dynamicEl[e].sizes) : ((p = c.$items.eq(e)).attr("data-poster") && (d = !0, o = p.attr("data-poster")), r = p.attr("data-html"), a = p.attr("href") || p.attr("data-src"), l = p.attr("title") || p.find("img").first().attr("alt"), p.attr("data-responsive") && h(p.attr("data-responsive").split(",")), n = p.attr("data-srcset"), p.attr("data-sizes")),
                h = !1;
            c.s.dynamic ? c.s.dynamicEl[e].iframe && (h = !0) : "true" === c.$items.eq(e).attr("data-iframe") && (h = !0);
            var p = c.isVideo(a, e);
            if (!c.$slide.eq(e).hasClass("lg-loaded")) {
                if (h ? c.$slide.eq(e).prepend('<div class="lg-video-cont lg-has-iframe" style="max-width:' + c.s.iframeMaxWidth + '"><div class="lg-video"><iframe class="lg-object" frameborder="0" src="' + a + '"  allowfullscreen="true"></iframe></div></div>') : d ? (h = "", h = p && p.youtube ? "lg-has-youtube" : p && p.vimeo ? "lg-has-vimeo" : "lg-has-html5", c.$slide.eq(e).prepend('<div class="lg-video-cont ' + h + ' "><div class="lg-video"><span class="lg-video-play"></span><img class="lg-object lg-has-poster" src="' + o + '" /></div></div>')) : p ? (c.$slide.eq(e).prepend('<div class="lg-video-cont "><div class="lg-video"></div></div>'), c.$el.trigger("hasVideo.lg", [e, a, r])) : (l = l ? 'alt="' + l + '"' : "", c.$slide.eq(e).prepend('<div class="lg-img-wrap"><img class="lg-object lg-image" ' + l + ' src="' + a + '" /></div>')), c.$el.trigger("onAferAppendSlide.lg", [e]), s = c.$slide.eq(e).find(".lg-object"), u && s.attr("sizes", u), n && (s.attr("srcset", n), this.s.supportLegacyBrowser)) try {
                    picturefill({elements: [s[0]]})
                } catch (t) {
                    console.warn("lightGallery :- If you want srcset to be supported for older browser please include picturefil version 2 javascript library in your document.")
                }
                ".lg-sub-html" !== this.s.appendSubHtmlTo && c.addHtml(e), c.$slide.eq(e).addClass("lg-loaded")
            }
            c.$slide.eq(e).find(".lg-object").on("load.lg error.lg", function () {
                var t = 0;
                i && !g("body").hasClass("lg-from-hash") && (t = i), setTimeout(function () {
                    c.$slide.eq(e).addClass("lg-complete"), c.$el.trigger("onSlideItemLoad.lg", [e, i || 0])
                }, t)
            }), p && p.html5 && !d && c.$slide.eq(e).addClass("lg-complete"), !0 === t && (c.$slide.eq(e).hasClass("lg-complete") ? c.preload(e) : c.$slide.eq(e).find(".lg-object").on("load.lg error.lg", function () {
                c.preload(e)
            }))
        }, e.prototype.slide = function (t, e, i, s) {
            var o, n, r, a, l, c = this.$outer.find(".lg-current").index(), d = this;
            d.lGalleryOn && c === t || (o = this.$slide.length, n = d.lGalleryOn ? this.s.speed : 0, d.lgBusy || (this.s.download && ((r = d.s.dynamic ? !1 !== d.s.dynamicEl[t].downloadUrl && (d.s.dynamicEl[t].downloadUrl || d.s.dynamicEl[t].src) : "false" !== d.$items.eq(t).attr("data-download-url") && (d.$items.eq(t).attr("data-download-url") || d.$items.eq(t).attr("href") || d.$items.eq(t).attr("data-src"))) ? (g("#lg-download").attr("href", r), d.$outer.removeClass("lg-hide-download")) : d.$outer.addClass("lg-hide-download")), this.$el.trigger("onBeforeSlide.lg", [c, t, e, i]), d.lgBusy = !0, clearTimeout(d.hideBarTimeout), ".lg-sub-html" === this.s.appendSubHtmlTo && setTimeout(function () {
                d.addHtml(t)
            }, n), this.arrowDisable(t), s || (t < c ? s = "prev" : c < t && (s = "next")), e ? (this.$slide.removeClass("lg-prev-slide lg-current lg-next-slide"), 2 < o ? (a = t - 1, l = t + 1, (0 === t && c === o - 1 || t === o - 1 && 0 === c) && (l = 0, a = o - 1)) : (a = 0, l = 1), "prev" === s ? d.$slide.eq(l).addClass("lg-next-slide") : d.$slide.eq(a).addClass("lg-prev-slide"), d.$slide.eq(t).addClass("lg-current")) : (d.$outer.addClass("lg-no-trans"), this.$slide.removeClass("lg-prev-slide lg-next-slide"), "prev" === s ? (this.$slide.eq(t).addClass("lg-prev-slide"), this.$slide.eq(c).addClass("lg-next-slide")) : (this.$slide.eq(t).addClass("lg-next-slide"), this.$slide.eq(c).addClass("lg-prev-slide")), setTimeout(function () {
                d.$slide.removeClass("lg-current"), d.$slide.eq(t).addClass("lg-current"), d.$outer.removeClass("lg-no-trans")
            }, 50)), d.lGalleryOn ? (setTimeout(function () {
                d.loadContent(t, !0, 0)
            }, this.s.speed + 50), setTimeout(function () {
                d.lgBusy = !1, d.$el.trigger("onAfterSlide.lg", [c, t, e, i])
            }, this.s.speed)) : (d.loadContent(t, !0, d.s.backdropDuration), d.lgBusy = !1, d.$el.trigger("onAfterSlide.lg", [c, t, e, i])), d.lGalleryOn = !0, this.s.counter && g("#lg-counter-current").text(t + 1)), d.index = t)
        }, e.prototype.goToNextSlide = function (t) {
            var e = this, i = e.s.loop;
            t && e.$slide.length < 3 && (i = !1), e.lgBusy || (e.index + 1 < e.$slide.length ? (e.index++, e.$el.trigger("onBeforeNextSlide.lg", [e.index]), e.slide(e.index, t, !1, "next")) : i ? (e.index = 0, e.$el.trigger("onBeforeNextSlide.lg", [e.index]), e.slide(e.index, t, !1, "next")) : e.s.slideEndAnimatoin && !t && (e.$outer.addClass("lg-right-end"), setTimeout(function () {
                e.$outer.removeClass("lg-right-end")
            }, 400)))
        }, e.prototype.goToPrevSlide = function (t) {
            var e = this, i = e.s.loop;
            t && e.$slide.length < 3 && (i = !1), e.lgBusy || (0 < e.index ? (e.index--, e.$el.trigger("onBeforePrevSlide.lg", [e.index, t]), e.slide(e.index, t, !1, "prev")) : i ? (e.index = e.$items.length - 1, e.$el.trigger("onBeforePrevSlide.lg", [e.index, t]), e.slide(e.index, t, !1, "prev")) : e.s.slideEndAnimatoin && !t && (e.$outer.addClass("lg-left-end"), setTimeout(function () {
                e.$outer.removeClass("lg-left-end")
            }, 400)))
        }, e.prototype.keyPress = function () {
            var e = this;
            1 < this.$items.length && g(window).on("keyup.lg", function (t) {
                1 < e.$items.length && (37 === t.keyCode && (t.preventDefault(), e.goToPrevSlide()), 39 === t.keyCode && (t.preventDefault(), e.goToNextSlide()))
            }), g(window).on("keydown.lg", function (t) {
                !0 === e.s.escKey && 27 === t.keyCode && (t.preventDefault(), e.$outer.hasClass("lg-thumb-open") ? e.$outer.removeClass("lg-thumb-open") : e.destroy())
            })
        }, e.prototype.arrow = function () {
            var t = this;
            this.$outer.find(".lg-prev").on("click.lg", function () {
                t.goToPrevSlide()
            }), this.$outer.find(".lg-next").on("click.lg", function () {
                t.goToNextSlide()
            })
        }, e.prototype.arrowDisable = function (t) {
            !this.s.loop && this.s.hideControlOnEnd && (t + 1 < this.$slide.length ? this.$outer.find(".lg-next").removeAttr("disabled").removeClass("disabled") : this.$outer.find(".lg-next").attr("disabled", "disabled").addClass("disabled"), 0 < t ? this.$outer.find(".lg-prev").removeAttr("disabled").removeClass("disabled") : this.$outer.find(".lg-prev").attr("disabled", "disabled").addClass("disabled"))
        }, e.prototype.setTranslate = function (t, e, i) {
            this.s.useLeft ? t.css("left", e) : t.css({transform: "translate3d(" + e + "px, " + i + "px, 0px)"})
        }, e.prototype.touchMove = function (t, e) {
            t = e - t;
            15 < Math.abs(t) && (this.$outer.addClass("lg-dragging"), this.setTranslate(this.$slide.eq(this.index), t, 0), this.setTranslate(g(".lg-prev-slide"), -this.$slide.eq(this.index).width() + t, 0), this.setTranslate(g(".lg-next-slide"), this.$slide.eq(this.index).width() + t, 0))
        }, e.prototype.touchEnd = function (t) {
            var e = this;
            "lg-slide" !== e.s.mode && e.$outer.addClass("lg-slide"), this.$slide.not(".lg-current, .lg-prev-slide, .lg-next-slide").css("opacity", "0"), setTimeout(function () {
                e.$outer.removeClass("lg-dragging"), t < 0 && Math.abs(t) > e.s.swipeThreshold ? e.goToNextSlide(!0) : 0 < t && Math.abs(t) > e.s.swipeThreshold ? e.goToPrevSlide(!0) : Math.abs(t) < 5 && e.$el.trigger("onSlideClick.lg"), e.$slide.removeAttr("style")
            }), setTimeout(function () {
                e.$outer.hasClass("lg-dragging") || "lg-slide" === e.s.mode || e.$outer.removeClass("lg-slide")
            }, e.s.speed + 100)
        }, e.prototype.enableSwipe = function () {
            var e = this, i = 0, s = 0, o = !1;
            e.s.enableSwipe && e.doCss() && (e.$slide.on("touchstart.lg", function (t) {
                e.$outer.hasClass("lg-zoomed") || e.lgBusy || (t.preventDefault(), e.manageSwipeClass(), i = t.originalEvent.targetTouches[0].pageX)
            }), e.$slide.on("touchmove.lg", function (t) {
                e.$outer.hasClass("lg-zoomed") || (t.preventDefault(), s = t.originalEvent.targetTouches[0].pageX, e.touchMove(i, s), o = !0)
            }), e.$slide.on("touchend.lg", function () {
                e.$outer.hasClass("lg-zoomed") || (o ? (o = !1, e.touchEnd(s - i)) : e.$el.trigger("onSlideClick.lg"))
            }))
        }, e.prototype.enableDrag = function () {
            var e = this, i = 0, s = 0, o = !1, n = !1;
            e.s.enableDrag && e.doCss() && (e.$slide.on("mousedown.lg", function (t) {
                e.$outer.hasClass("lg-zoomed") || e.lgBusy || g(t.target).text().trim() || (t.preventDefault(), e.manageSwipeClass(), i = t.pageX, o = !0, e.$outer.scrollLeft += 1, --e.$outer.scrollLeft, e.$outer.removeClass("lg-grab").addClass("lg-grabbing"), e.$el.trigger("onDragstart.lg"))
            }), g(window).on("mousemove.lg", function (t) {
                o && (n = !0, s = t.pageX, e.touchMove(i, s), e.$el.trigger("onDragmove.lg"))
            }), g(window).on("mouseup.lg", function (t) {
                n ? (n = !1, e.touchEnd(s - i), e.$el.trigger("onDragend.lg")) : (g(t.target).hasClass("lg-object") || g(t.target).hasClass("lg-video-play")) && e.$el.trigger("onSlideClick.lg"), o && (o = !1, e.$outer.removeClass("lg-grabbing").addClass("lg-grab"))
            }))
        }, e.prototype.manageSwipeClass = function () {
            var t = this.index + 1, e = this.index - 1;
            this.s.loop && 2 < this.$slide.length && (0 === this.index ? e = this.$slide.length - 1 : this.index === this.$slide.length - 1 && (t = 0)), this.$slide.removeClass("lg-next-slide lg-prev-slide"), -1 < e && this.$slide.eq(e).addClass("lg-prev-slide"), this.$slide.eq(t).addClass("lg-next-slide")
        }, e.prototype.mousewheel = function () {
            var e = this;
            e.$outer.on("mousewheel.lg", function (t) {
                t.deltaY && (0 < t.deltaY ? e.goToPrevSlide() : e.goToNextSlide(), t.preventDefault())
            })
        }, e.prototype.closeGallery = function () {
            var e = this, i = !1;
            this.$outer.find(".lg-close").on("click.lg", function () {
                e.destroy()
            }), e.s.closable && (e.$outer.on("mousedown.lg", function (t) {
                i = !!(g(t.target).is(".lg-outer") || g(t.target).is(".lg-item ") || g(t.target).is(".lg-img-wrap"))
            }), e.$outer.on("mousemove.lg", function () {
                i = !1
            }), e.$outer.on("mouseup.lg", function (t) {
                (g(t.target).is(".lg-outer") || g(t.target).is(".lg-item ") || g(t.target).is(".lg-img-wrap") && i) && (e.$outer.hasClass("lg-dragging") || e.destroy())
            }))
        }, e.prototype.destroy = function (t) {
            var e = this;
            t || (e.$el.trigger("onBeforeClose.lg"), g(window).scrollTop(e.prevScrollTop)), t && (e.s.dynamic || this.$items.off("click.lg click.lgcustom"), g.removeData(e.el, "lightGallery")), this.$el.off(".lg.tm"), g.each(g.fn.lightGallery.modules, function (t) {
                e.modules[t] && e.modules[t].destroy()
            }), this.lGalleryOn = !1, clearTimeout(e.hideBarTimeout), this.hideBarTimeout = !1, g(window).off(".lg"), g("body").removeClass("lg-on lg-from-hash"), e.$outer && e.$outer.removeClass("lg-visible"), g(".lg-backdrop").removeClass("in"), setTimeout(function () {
                e.$outer && e.$outer.remove(), g(".lg-backdrop").remove(), t || e.$el.trigger("onCloseAfter.lg"), e.$el.focus()
            }, e.s.backdropDuration + 50)
        }, g.fn.lightGallery = function (t) {
            return this.each(function () {
                if (g.data(this, "lightGallery")) try {
                    g(this).data("lightGallery").init()
                } catch (t) {
                    console.error("lightGallery has not initiated properly", t)
                } else g.data(this, "lightGallery", new e(this, t))
            })
        }, g.fn.lightGallery.modules = {}
    }()
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (i) {
    !function () {
        "use strict";

        function t(t) {
            return this.core = i(t).data("lightGallery"), this.$el = i(t), !(this.core.$items.length < 2) && (this.core.s = i.extend({}, e, this.core.s), this.interval = !1, this.fromAuto = !0, this.canceledOnTouch = !1, this.fourceAutoplayTemp = this.core.s.fourceAutoplay, this.core.doCss() || (this.core.s.progressBar = !1), this.init(), this)
        }

        var e = {
            autoplay: !1,
            pause: 5e3,
            progressBar: !0,
            fourceAutoplay: !1,
            autoplayControls: !0,
            appendAutoplayControlsTo: ".lg-toolbar"
        };
        t.prototype.init = function () {
            var t = this;
            t.core.s.autoplayControls && t.controls(), t.core.s.progressBar && t.core.$outer.find(".lg").append('<div class="lg-progress-bar"><div class="lg-progress"></div></div>'), t.progress(), t.core.s.autoplay && t.$el.one("onSlideItemLoad.lg.tm", function () {
                t.startlAuto()
            }), t.$el.on("onDragstart.lg.tm touchstart.lg.tm", function () {
                t.interval && (t.cancelAuto(), t.canceledOnTouch = !0)
            }), t.$el.on("onDragend.lg.tm touchend.lg.tm onSlideClick.lg.tm", function () {
                !t.interval && t.canceledOnTouch && (t.startlAuto(), t.canceledOnTouch = !1)
            })
        }, t.prototype.progress = function () {
            var t, e, i = this;
            i.$el.on("onBeforeSlide.lg.tm", function () {
                i.core.s.progressBar && i.fromAuto && (t = i.core.$outer.find(".lg-progress-bar"), e = i.core.$outer.find(".lg-progress"), i.interval && (e.removeAttr("style"), t.removeClass("lg-start"), setTimeout(function () {
                    e.css("transition", "width " + (i.core.s.speed + i.core.s.pause) + "ms ease 0s"), t.addClass("lg-start")
                }, 20))), i.fromAuto || i.core.s.fourceAutoplay || i.cancelAuto(), i.fromAuto = !1
            })
        }, t.prototype.controls = function () {
            var t = this;
            i(this.core.s.appendAutoplayControlsTo).append('<button type="button" aria-label="Toggle autoplay" class="lg-autoplay-button lg-icon"></button>'), t.core.$outer.find(".lg-autoplay-button").on("click.lg", function () {
                i(t.core.$outer).hasClass("lg-show-autoplay") ? (t.cancelAuto(), t.core.s.fourceAutoplay = !1) : t.interval || (t.startlAuto(), t.core.s.fourceAutoplay = t.fourceAutoplayTemp)
            })
        }, t.prototype.startlAuto = function () {
            var t = this;
            t.core.$outer.find(".lg-progress").css("transition", "width " + (t.core.s.speed + t.core.s.pause) + "ms ease 0s"), t.core.$outer.addClass("lg-show-autoplay"), t.core.$outer.find(".lg-progress-bar").addClass("lg-start"), t.interval = setInterval(function () {
                t.core.index + 1 < t.core.$items.length ? t.core.index++ : t.core.index = 0, t.fromAuto = !0, t.core.slide(t.core.index, !1, !1, "next")
            }, t.core.s.speed + t.core.s.pause)
        }, t.prototype.cancelAuto = function () {
            clearInterval(this.interval), this.interval = !1, this.core.$outer.find(".lg-progress").removeAttr("style"), this.core.$outer.removeClass("lg-show-autoplay"), this.core.$outer.find(".lg-progress-bar").removeClass("lg-start")
        }, t.prototype.destroy = function () {
            this.cancelAuto(), this.core.$outer.find(".lg-progress-bar").remove()
        }, i.fn.lightGallery.modules.autoplay = t
    }()
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (s) {
    !function () {
        "use strict";
        var e = {fullScreen: !0};

        function i() {
            return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement
        }

        function t(t) {
            return this.core = s(t).data("lightGallery"), this.$el = s(t), this.core.s = s.extend({}, e, this.core.s), this.init(), this
        }

        t.prototype.init = function () {
            this.core.s.fullScreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled) && (this.core.$outer.find(".lg-toolbar").append('<button type="button" aria-label="Toggle fullscreen" class="lg-fullscreen lg-icon"></button>'), this.fullScreen())
        }, t.prototype.requestFullscreen = function () {
            var t = document.documentElement;
            t.requestFullscreen ? t.requestFullscreen() : t.msRequestFullscreen ? t.msRequestFullscreen() : t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.webkitRequestFullscreen && t.webkitRequestFullscreen()
        }, t.prototype.exitFullscreen = function () {
            document.exitFullscreen ? document.exitFullscreen() : document.msExitFullscreen ? document.msExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen()
        }, t.prototype.fullScreen = function () {
            var t = this;
            s(document).on("fullscreenchange.lg webkitfullscreenchange.lg mozfullscreenchange.lg MSFullscreenChange.lg", function () {
                t.core.$outer.toggleClass("lg-fullscreen-on")
            }), this.core.$outer.find(".lg-fullscreen").on("click.lg", function () {
                i() ? t.exitFullscreen() : t.requestFullscreen()
            })
        }, t.prototype.destroy = function () {
            i() && this.exitFullscreen(), s(document).off("fullscreenchange.lg webkitfullscreenchange.lg mozfullscreenchange.lg MSFullscreenChange.lg")
        }, s.fn.lightGallery.modules.fullscreen = t
    }()
}), function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function (r) {
    !function () {
        "use strict";

        function t(t) {
            return this.core = r(t).data("lightGallery"), this.$el = r(t), this.core.s = r.extend({}, e, this.core.s), this.core.s.pager && 1 < this.core.$items.length && this.init(), this
        }

        var e = {pager: !1};
        t.prototype.init = function () {
            var s, t, e, i = this, o = "";
            if (i.core.$outer.find(".lg").append('<div class="lg-pager-outer"></div>'), i.core.s.dynamic) for (var n = 0; n < i.core.s.dynamicEl.length; n++) o += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + i.core.s.dynamicEl[n].thumb + '" /></div></span>'; else i.core.$items.each(function () {
                i.core.s.exThumbImage ? o += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + r(this).attr(i.core.s.exThumbImage) + '" /></div></span>' : o += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + r(this).find("img").attr("src") + '" /></div></span>'
            });
            (t = i.core.$outer.find(".lg-pager-outer")).html(o), (s = i.core.$outer.find(".lg-pager-cont")).on("click.lg touchend.lg", function () {
                var t = r(this);
                i.core.index = t.index(), i.core.slide(i.core.index, !1, !0, !1)
            }), t.on("mouseover.lg", function () {
                clearTimeout(e), t.addClass("lg-pager-hover")
            }), t.on("mouseout.lg", function () {
                e = setTimeout(function () {
                    t.removeClass("lg-pager-hover")
                })
            }), i.core.$el.on("onBeforeSlide.lg.tm", function (t, e, i) {
                s.removeClass("lg-pager-active"), s.eq(i).addClass("lg-pager-active")
            })
        }, t.prototype.destroy = function () {
        }, r.fn.lightGallery.modules.pager = t
    }()
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (a) {
    !function () {
        "use strict";

        function t(t) {
            return this.core = a(t).data("lightGallery"), this.core.s = a.extend({}, e, this.core.s), this.$el = a(t), this.$thumbOuter = null, this.thumbOuterWidth = 0, this.thumbTotalWidth = this.core.$items.length * (this.core.s.thumbWidth + this.core.s.thumbMargin), this.thumbIndex = this.core.index, this.core.s.animateThumb && (this.core.s.thumbHeight = "100%"), this.left = 0, this.init(), this
        }

        var e = {
            thumbnail: !0,
            animateThumb: !0,
            currentPagerPosition: "middle",
            thumbWidth: 100,
            thumbHeight: "80px",
            thumbContHeight: 100,
            thumbMargin: 5,
            exThumbImage: !1,
            showThumbByDefault: !0,
            toogleThumb: !0,
            pullCaptionUp: !0,
            enableThumbDrag: !0,
            enableThumbSwipe: !0,
            swipeThreshold: 50,
            loadYoutubeThumbnail: !0,
            youtubeThumbSize: 1,
            loadVimeoThumbnail: !0,
            vimeoThumbSize: "thumbnail_small",
            loadDailymotionThumbnail: !0
        };
        t.prototype.init = function () {
            var t = this;
            this.core.s.thumbnail && 1 < this.core.$items.length && (this.core.s.showThumbByDefault && setTimeout(function () {
                t.core.$outer.addClass("lg-thumb-open")
            }, 700), this.core.s.pullCaptionUp && this.core.$outer.addClass("lg-pull-caption-up"), this.build(), this.core.s.animateThumb && this.core.doCss() ? (this.core.s.enableThumbDrag && this.enableThumbDrag(), this.core.s.enableThumbSwipe && this.enableThumbSwipe(), this.thumbClickable = !1) : this.thumbClickable = !0, this.toogle(), this.thumbkeyPress())
        }, t.prototype.build = function () {
            var t, o = this, n = "", r = "";
            switch (this.core.s.vimeoThumbSize) {
                case"thumbnail_large":
                    r = "640";
                    break;
                case"thumbnail_medium":
                    r = "200x150";
                    break;
                case"thumbnail_small":
                    r = "100x75"
            }

            function e(t, e, i) {
                var s, t = o.core.isVideo(t, i) || {}, i = "";
                t.youtube || t.vimeo || t.dailymotion ? t.youtube ? s = o.core.s.loadYoutubeThumbnail ? "//img.youtube.com/vi/" + t.youtube[1] + "/" + o.core.s.youtubeThumbSize + ".jpg" : e : t.vimeo ? o.core.s.loadVimeoThumbnail ? (s = "//i.vimeocdn.com/video/error_" + r + ".jpg", i = t.vimeo[1]) : s = e : t.dailymotion && (s = o.core.s.loadDailymotionThumbnail ? "//www.dailymotion.com/thumbnail/video/" + t.dailymotion[1] : e) : s = e, n += '<div data-vimeo-id="' + i + '" class="lg-thumb-item" style="width:' + o.core.s.thumbWidth + "px; height: " + o.core.s.thumbHeight + "; margin-right: " + o.core.s.thumbMargin + 'px"><img src="' + s + '" /></div>', i = ""
            }

            if (o.core.$outer.addClass("lg-has-thumb"), o.core.$outer.find(".lg").append('<div class="lg-thumb-outer"><div class="lg-thumb lg-group"></div></div>'), o.$thumbOuter = o.core.$outer.find(".lg-thumb-outer"), o.thumbOuterWidth = o.$thumbOuter.width(), o.core.s.animateThumb && o.core.$outer.find(".lg-thumb").css({
                width: o.thumbTotalWidth + "px",
                position: "relative"
            }), this.core.s.animateThumb && o.$thumbOuter.css("height", o.core.s.thumbContHeight + "px"), o.core.s.dynamic) for (var i = 0; i < o.core.s.dynamicEl.length; i++) e(o.core.s.dynamicEl[i].src, o.core.s.dynamicEl[i].thumb, i); else o.core.$items.each(function (t) {
                o.core.s.exThumbImage ? e(a(this).attr("href") || a(this).attr("data-src"), a(this).attr(o.core.s.exThumbImage), t) : e(a(this).attr("href") || a(this).attr("data-src"), a(this).find("img").attr("src"), t)
            });
            o.core.$outer.find(".lg-thumb").html(n), (t = o.core.$outer.find(".lg-thumb-item")).each(function () {
                var e = a(this), t = e.attr("data-vimeo-id");
                t && a.getJSON("//www.vimeo.com/api/v2/video/" + t + ".json?callback=?", {format: "json"}, function (t) {
                    e.find("img").attr("src", t[0][o.core.s.vimeoThumbSize])
                })
            }), t.eq(o.core.index).addClass("active"), o.core.$el.on("onBeforeSlide.lg.tm", function () {
                t.removeClass("active"), t.eq(o.core.index).addClass("active")
            }), t.on("click.lg touchend.lg", function () {
                var t = a(this);
                setTimeout(function () {
                    (!o.thumbClickable || o.core.lgBusy) && o.core.doCss() || (o.core.index = t.index(), o.core.slide(o.core.index, !1, !0, !1))
                }, 50)
            }), o.core.$el.on("onBeforeSlide.lg.tm", function () {
                o.animateThumb(o.core.index)
            }), a(window).on("resize.lg.thumb orientationchange.lg.thumb", function () {
                setTimeout(function () {
                    o.animateThumb(o.core.index), o.thumbOuterWidth = o.$thumbOuter.width()
                }, 200)
            })
        }, t.prototype.setTranslate = function (t) {
            this.core.$outer.find(".lg-thumb").css({transform: "translate3d(-" + t + "px, 0px, 0px)"})
        }, t.prototype.animateThumb = function (t) {
            var e, i = this.core.$outer.find(".lg-thumb");
            if (this.core.s.animateThumb) {
                switch (this.core.s.currentPagerPosition) {
                    case"left":
                        e = 0;
                        break;
                    case"middle":
                        e = this.thumbOuterWidth / 2 - this.core.s.thumbWidth / 2;
                        break;
                    case"right":
                        e = this.thumbOuterWidth - this.core.s.thumbWidth
                }
                this.left = (this.core.s.thumbWidth + this.core.s.thumbMargin) * t - 1 - e, this.left > this.thumbTotalWidth - this.thumbOuterWidth && (this.left = this.thumbTotalWidth - this.thumbOuterWidth), this.left < 0 && (this.left = 0), this.core.lGalleryOn ? (i.hasClass("on") || this.core.$outer.find(".lg-thumb").css("transition-duration", this.core.s.speed + "ms"), this.core.doCss() || i.animate({left: -this.left + "px"}, this.core.s.speed)) : this.core.doCss() || i.css("left", -this.left + "px"), this.setTranslate(this.left)
            }
        }, t.prototype.enableThumbDrag = function () {
            var e = this, i = 0, s = 0, o = !1, n = !1, r = 0;
            e.$thumbOuter.addClass("lg-grab"), e.core.$outer.find(".lg-thumb").on("mousedown.lg.thumb", function (t) {
                e.thumbTotalWidth > e.thumbOuterWidth && (t.preventDefault(), i = t.pageX, o = !0, e.core.$outer.scrollLeft += 1, --e.core.$outer.scrollLeft, e.thumbClickable = !1, e.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing"))
            }), a(window).on("mousemove.lg.thumb", function (t) {
                o && (r = e.left, n = !0, s = t.pageX, e.$thumbOuter.addClass("lg-dragging"), (r -= s - i) > e.thumbTotalWidth - e.thumbOuterWidth && (r = e.thumbTotalWidth - e.thumbOuterWidth), r < 0 && (r = 0), e.setTranslate(r))
            }), a(window).on("mouseup.lg.thumb", function () {
                n ? (n = !1, e.$thumbOuter.removeClass("lg-dragging"), e.left = r, Math.abs(s - i) < e.core.s.swipeThreshold && (e.thumbClickable = !0)) : e.thumbClickable = !0, o && (o = !1, e.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab"))
            })
        }, t.prototype.enableThumbSwipe = function () {
            var e = this, i = 0, s = 0, o = !1, n = 0;
            e.core.$outer.find(".lg-thumb").on("touchstart.lg", function (t) {
                e.thumbTotalWidth > e.thumbOuterWidth && (t.preventDefault(), i = t.originalEvent.targetTouches[0].pageX, e.thumbClickable = !1)
            }), e.core.$outer.find(".lg-thumb").on("touchmove.lg", function (t) {
                e.thumbTotalWidth > e.thumbOuterWidth && (t.preventDefault(), s = t.originalEvent.targetTouches[0].pageX, o = !0, e.$thumbOuter.addClass("lg-dragging"), n = e.left, (n -= s - i) > e.thumbTotalWidth - e.thumbOuterWidth && (n = e.thumbTotalWidth - e.thumbOuterWidth), n < 0 && (n = 0), e.setTranslate(n))
            }), e.core.$outer.find(".lg-thumb").on("touchend.lg", function () {
                e.thumbTotalWidth > e.thumbOuterWidth && o ? (o = !1, e.$thumbOuter.removeClass("lg-dragging"), Math.abs(s - i) < e.core.s.swipeThreshold && (e.thumbClickable = !0), e.left = n) : e.thumbClickable = !0
            })
        }, t.prototype.toogle = function () {
            var t = this;
            t.core.s.toogleThumb && (t.core.$outer.addClass("lg-can-toggle"), t.$thumbOuter.append('<button type="button" aria-label="Toggle thumbnails" class="lg-toogle-thumb lg-icon"></button>'), t.core.$outer.find(".lg-toogle-thumb").on("click.lg", function () {
                t.core.$outer.toggleClass("lg-thumb-open")
            }))
        }, t.prototype.thumbkeyPress = function () {
            var e = this;
            a(window).on("keydown.lg.thumb", function (t) {
                38 === t.keyCode ? (t.preventDefault(), e.core.$outer.addClass("lg-thumb-open")) : 40 === t.keyCode && (t.preventDefault(), e.core.$outer.removeClass("lg-thumb-open"))
            })
        }, t.prototype.destroy = function () {
            this.core.s.thumbnail && 1 < this.core.$items.length && (a(window).off("resize.lg.thumb orientationchange.lg.thumb keydown.lg.thumb"), this.$thumbOuter.remove(), this.core.$outer.removeClass("lg-has-thumb"))
        }, a.fn.lightGallery.modules.Thumbnail = t
    }()
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (c) {
    !function () {
        "use strict";

        function t(t) {
            return this.core = c(t).data("lightGallery"), this.$el = c(t), this.core.s = c.extend({}, e, this.core.s), this.videoLoaded = !1, this.init(), this
        }

        var e = {
            videoMaxWidth: "855px",
            autoplayFirstVideo: !0,
            youtubePlayerParams: !1,
            vimeoPlayerParams: !1,
            dailymotionPlayerParams: !1,
            vkPlayerParams: !1,
            videojs: !1,
            videojsOptions: {}
        };
        t.prototype.init = function () {
            var s = this;
            s.core.$el.on("hasVideo.lg.tm", function (t, e, i, s) {
                var o = this;
                if (o.core.$slide.eq(e).find(".lg-video").append(o.loadVideo(i, "lg-object", !0, e, s)), s) if (o.core.s.videojs) try {
                    videojs(o.core.$slide.eq(e).find(".lg-html5").get(0), o.core.s.videojsOptions, function () {
                        !o.videoLoaded && o.core.s.autoplayFirstVideo && this.play()
                    })
                } catch (t) {
                    console.error("Make sure you have included videojs")
                } else !o.videoLoaded && o.core.s.autoplayFirstVideo && o.core.$slide.eq(e).find(".lg-html5").get(0).play()
            }.bind(this)), s.core.$el.on("onAferAppendSlide.lg.tm", function (t, e) {
                e = this.core.$slide.eq(e).find(".lg-video-cont");
                e.hasClass("lg-has-iframe") || (e.css("max-width", this.core.s.videoMaxWidth), this.videoLoaded = !0)
            }.bind(this)), s.core.doCss() && 1 < s.core.$items.length && (s.core.s.enableSwipe || s.core.s.enableDrag) ? s.core.$el.on("onSlideClick.lg.tm", function () {
                var t = s.core.$slide.eq(s.core.index);
                s.loadVideoOnclick(t)
            }) : s.core.$slide.on("click.lg", function () {
                s.loadVideoOnclick(c(this))
            }), s.core.$el.on("onBeforeSlide.lg.tm", function (t, e, i) {
                var s = this, o = s.core.$slide.eq(e), n = o.find(".lg-youtube").get(0), r = o.find(".lg-vimeo").get(0),
                    a = o.find(".lg-dailymotion").get(0), e = o.find(".lg-vk").get(0), l = o.find(".lg-html5").get(0);
                if (n) n.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*"); else if (r) try {
                    $f(r).api("pause")
                } catch (t) {
                    console.error("Make sure you have included froogaloop2 js")
                } else if (a) a.contentWindow.postMessage("pause", "*"); else if (l) if (s.core.s.videojs) try {
                    videojs(l).pause()
                } catch (t) {
                    console.error("Make sure you have included videojs")
                } else l.pause();
                e && c(e).attr("src", c(e).attr("src").replace("&autoplay", "&noplay"));
                e = s.core.s.dynamic ? s.core.s.dynamicEl[i].src : s.core.$items.eq(i).attr("href") || s.core.$items.eq(i).attr("data-src");
                i = s.core.isVideo(e, i) || {};
                (i.youtube || i.vimeo || i.dailymotion || i.vk) && s.core.$outer.addClass("lg-hide-download")
            }.bind(this)), s.core.$el.on("onAfterSlide.lg.tm", function (t, e) {
                s.core.$slide.eq(e).removeClass("lg-video-playing")
            }), s.core.s.autoplayFirstVideo && s.core.$el.on("onAferAppendSlide.lg.tm", function (t, e) {
                var i;
                s.core.lGalleryOn || (i = s.core.$slide.eq(e), setTimeout(function () {
                    s.loadVideoOnclick(i)
                }, 100))
            })
        }, t.prototype.loadVideo = function (t, e, i, s, o) {
            var n = this, r = "", a = 1, l = "", s = this.core.isVideo(t, s) || {},
                n = n.core.s.dynamic ? n.core.s.dynamicEl[n.core.index].title : n.core.$items.eq(n.core.index).attr("title") || n.core.$items.eq(n.core.index).find("img").first().attr("alt");
            return n = n ? 'title="' + n + '"' : "", i && (a = !this.videoLoaded && this.core.s.autoplayFirstVideo ? 1 : 0), s.youtube ? (l = "?wmode=opaque&autoplay=" + a + "&enablejsapi=1", this.core.s.youtubePlayerParams && (l = l + "&" + c.param(this.core.s.youtubePlayerParams)), r = '<iframe class="lg-video-object lg-youtube ' + e + '" ' + n + ' width="560" height="315" src="//www.youtube.com/embed/' + s.youtube[1] + l + '" frameborder="0" allowfullscreen></iframe>') : s.vimeo ? (l = "?autoplay=" + a + "&api=1", this.core.s.vimeoPlayerParams && (l = l + "&" + c.param(this.core.s.vimeoPlayerParams)), r = '<iframe class="lg-video-object lg-vimeo ' + e + '" ' + n + ' width="560" height="315"  src="//player.vimeo.com/video/' + s.vimeo[1] + l + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>') : s.dailymotion ? (l = "?wmode=opaque&autoplay=" + a + "&api=postMessage", this.core.s.dailymotionPlayerParams && (l = l + "&" + c.param(this.core.s.dailymotionPlayerParams)), r = '<iframe class="lg-video-object lg-dailymotion ' + e + '" ' + n + ' width="560" height="315" src="//www.dailymotion.com/embed/video/' + s.dailymotion[1] + l + '" frameborder="0" allowfullscreen></iframe>') : s.html5 ? ("." !== (i = o.substring(0, 1)) && "#" !== i || (o = c(o).html()), r = o) : s.vk && (l = "&autoplay=" + a, this.core.s.vkPlayerParams && (l = l + "&" + c.param(this.core.s.vkPlayerParams)), r = '<iframe class="lg-video-object lg-vk ' + e + '" ' + n + ' width="560" height="315" src="//vk.com/video_ext.php?' + s.vk[1] + l + '" frameborder="0" allowfullscreen></iframe>'), r
        }, t.prototype.loadVideoOnclick = function (i) {
            var s = this;
            if (i.find(".lg-object").hasClass("lg-has-poster") && i.find(".lg-object").is(":visible")) if (i.hasClass("lg-has-video")) {
                var t = i.find(".lg-youtube").get(0), e = i.find(".lg-vimeo").get(0),
                    o = i.find(".lg-dailymotion").get(0), n = i.find(".lg-html5").get(0);
                if (t) t.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*"); else if (e) try {
                    $f(e).api("play")
                } catch (t) {
                    console.error("Make sure you have included froogaloop2 js")
                } else if (o) o.contentWindow.postMessage("play", "*"); else if (n) if (s.core.s.videojs) try {
                    videojs(n).play()
                } catch (t) {
                    console.error("Make sure you have included videojs")
                } else n.play();
                i.addClass("lg-video-playing")
            } else {
                i.addClass("lg-video-playing lg-has-video");
                o = function (t, e) {
                    if (i.find(".lg-video").append(s.loadVideo(t, "", !1, s.core.index, e)), e) if (s.core.s.videojs) try {
                        videojs(s.core.$slide.eq(s.core.index).find(".lg-html5").get(0), s.core.s.videojsOptions, function () {
                            this.play()
                        })
                    } catch (t) {
                        console.error("Make sure you have included videojs")
                    } else s.core.$slide.eq(s.core.index).find(".lg-html5").get(0).play()
                };
                s.core.s.dynamic ? o(s.core.s.dynamicEl[s.core.index].src, s.core.s.dynamicEl[s.core.index].html) : o(s.core.$items.eq(s.core.index).attr("href") || s.core.$items.eq(s.core.index).attr("data-src"), s.core.$items.eq(s.core.index).attr("data-html"));
                o = i.find(".lg-object");
                i.find(".lg-video").append(o), i.find(".lg-video-object").hasClass("lg-html5") || (i.removeClass("lg-complete"), i.find(".lg-video-object").on("load.lg error.lg", function () {
                    i.addClass("lg-complete")
                }))
            }
        }, t.prototype.destroy = function () {
            this.videoLoaded = !1
        }, c.fn.lightGallery.modules.video = t
    }()
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (u) {
    !function () {
        "use strict";

        function t(t) {
            return this.core = u(t).data("lightGallery"), this.core.s = u.extend({}, s, this.core.s), this.core.s.zoom && this.core.doCss() && (this.init(), this.zoomabletimeout = !1, this.pageX = u(window).width() / 2, this.pageY = u(window).height() / 2 + u(window).scrollTop()), this
        }

        var e, i, s = {
            scale: 1,
            zoom: !0,
            actualSize: !0,
            enableZoomAfter: 300,
            useLeftForZoom: (e = !1, (i = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)) && parseInt(i[2], 10) < 54 && (e = !0), e)
        };
        t.prototype.init = function () {
            var n = this,
                t = '<button type="button" aria-label="Zoom in" id="lg-zoom-in" class="lg-icon"></button><button type="button" aria-label="Zoom out" id="lg-zoom-out" class="lg-icon"></button>';
            n.core.s.actualSize && (t += '<button type="button" aria-label="Actual size" id="lg-actual-size" class="lg-icon"></button>'), n.core.s.useLeftForZoom ? n.core.$outer.addClass("lg-use-left-for-zoom") : n.core.$outer.addClass("lg-use-transition-for-zoom"), this.core.$outer.find(".lg-toolbar").append(t), n.core.$el.on("onSlideItemLoad.lg.tm.zoom", function (t, e, i) {
                var s = n.core.s.enableZoomAfter + i;
                u("body").hasClass("lg-from-hash") && i ? s = 0 : u("body").removeClass("lg-from-hash"), n.zoomabletimeout = setTimeout(function () {
                    n.core.$slide.eq(e).addClass("lg-zoomable")
                }, s + 30)
            });

            function e(t) {
                var e = n.core.$outer.find(".lg-current .lg-image"),
                    i = (u(window).width() - e.prop("offsetWidth")) / 2,
                    s = (u(window).height() - e.prop("offsetHeight")) / 2 + u(window).scrollTop(),
                    i = (t - 1) * (n.pageX - i), s = (t - 1) * (n.pageY - s);
                e.css("transform", "scale3d(" + t + ", " + t + ", 1)").attr("data-scale", t), (n.core.s.useLeftForZoom ? e.parent().css({
                    left: -i + "px",
                    top: -s + "px"
                }) : e.parent().css("transform", "translate3d(-" + i + "px, -" + s + "px, 0)")).attr("data-x", i).attr("data-y", s)
            }

            function r() {
                1 < a ? n.core.$outer.addClass("lg-zoomed") : n.resetZoom(), a < 1 && (a = 1), e(a)
            }

            function s(t, e, i, s) {
                var o = e.prop("offsetWidth"),
                    e = n.core.s.dynamic ? n.core.s.dynamicEl[i].width || e[0].naturalWidth || o : n.core.$items.eq(i).attr("data-width") || e[0].naturalWidth || o;
                n.core.$outer.hasClass("lg-zoomed") ? a = 1 : o < e && (a = e / o || 2), s ? (n.pageX = u(window).width() / 2, n.pageY = u(window).height() / 2 + u(window).scrollTop()) : (n.pageX = t.pageX || t.originalEvent.targetTouches[0].pageX, n.pageY = t.pageY || t.originalEvent.targetTouches[0].pageY), r(), setTimeout(function () {
                    n.core.$outer.removeClass("lg-grabbing").addClass("lg-grab")
                }, 10)
            }

            var a = 1, o = !1;
            n.core.$el.on("onAferAppendSlide.lg.tm.zoom", function (t, e) {
                var i = n.core.$slide.eq(e).find(".lg-image");
                i.on("dblclick", function (t) {
                    s(t, i, e)
                }), i.on("touchstart", function (t) {
                    o ? (clearTimeout(o), o = null, s(t, i, e)) : o = setTimeout(function () {
                        o = null
                    }, 300), t.preventDefault()
                })
            }), u(window).on("resize.lg.zoom scroll.lg.zoom orientationchange.lg.zoom", function () {
                n.pageX = u(window).width() / 2, n.pageY = u(window).height() / 2 + u(window).scrollTop(), e(a)
            }), u("#lg-zoom-out").on("click.lg", function () {
                n.core.$outer.find(".lg-current .lg-image").length && (a -= n.core.s.scale, r())
            }), u("#lg-zoom-in").on("click.lg", function () {
                n.core.$outer.find(".lg-current .lg-image").length && (a += n.core.s.scale, r())
            }), u("#lg-actual-size").on("click.lg", function (t) {
                s(t, n.core.$slide.eq(n.core.index).find(".lg-image"), n.core.index, !0)
            }), n.core.$el.on("onBeforeSlide.lg.tm", function () {
                a = 1, n.resetZoom()
            }), n.zoomDrag(), n.zoomSwipe()
        }, t.prototype.getCurrentTransform = function (t) {
            if (!t) return 0;
            t = window.getComputedStyle(t, null), t = t.getPropertyValue("-webkit-transform") || t.getPropertyValue("-moz-transform") || t.getPropertyValue("-ms-transform") || t.getPropertyValue("-o-transform") || t.getPropertyValue("transform") || "none";
            return "none" !== t ? t.split("(")[1].split(")")[0].split(",") : 0
        }, t.prototype.getCurrentRotation = function (t) {
            if (!t) return 0;
            t = this.getCurrentTransform(t);
            return t ? Math.round(Math.atan2(t[1], t[0]) * (180 / Math.PI)) : 0
        }, t.prototype.getModifier = function (t, e, i) {
            var s = t;
            t = Math.abs(t);
            var o = this.getCurrentTransform(i);
            if (!o) return 1;
            var n, i = 1;
            return "X" === e ? (n = Math.sign(parseFloat(o[0])), 0 === t || 180 === t ? i = 1 : 90 === t && (i = -90 === s && 1 === n || 90 === s && -1 === n ? -1 : 1), i *= n) : (n = Math.sign(parseFloat(o[3])), 0 === t || 180 === t ? i = 1 : 90 === t && (t = parseFloat(o[1]), o = parseFloat(o[2]), i = Math.sign(t * o * s * n)), i *= n), i
        }, t.prototype.getImageSize = function (t, e, i) {
            return 90 === e && (i = "x" === i ? "y" : "x"), t.prop({y: "offsetHeight", x: "offsetWidth"}[i])
        }, t.prototype.getDragCords = function (t, e) {
            return 90 === e ? {x: t.pageY, y: t.pageX} : {x: t.pageX, y: t.pageY}
        }, t.prototype.getSwipeCords = function (t, e) {
            var i = t.originalEvent.targetTouches[0].pageX, t = t.originalEvent.targetTouches[0].pageY;
            return 90 === e ? {x: t, y: i} : {x: i, y: t}
        }, t.prototype.getPossibleDragCords = function (t, e) {
            var i = (this.core.$outer.find(".lg").height() - this.getImageSize(t, e, "y")) / 2,
                s = Math.abs(this.getImageSize(t, e, "y") * Math.abs(t.attr("data-scale")) - this.core.$outer.find(".lg").height() + i),
                o = (this.core.$outer.find(".lg").width() - this.getImageSize(t, e, "x")) / 2,
                t = Math.abs(this.getImageSize(t, e, "x") * Math.abs(t.attr("data-scale")) - this.core.$outer.find(".lg").width() + o);
            return 90 === e ? {minY: o, maxY: t, minX: i, maxX: s} : {minY: i, maxY: s, minX: o, maxX: t}
        }, t.prototype.getDragAllowedAxises = function (t, e) {
            var i = this.getImageSize(t, e, "y") * t.attr("data-scale") > this.core.$outer.find(".lg").height(),
                t = this.getImageSize(t, e, "x") * t.attr("data-scale") > this.core.$outer.find(".lg").width();
            return 90 === e ? {allowX: i, allowY: t} : {allowX: t, allowY: i}
        }, t.prototype.resetZoom = function () {
            this.core.$outer.removeClass("lg-zoomed"), this.core.$slide.find(".lg-img-wrap").removeAttr("style data-x data-y"), this.core.$slide.find(".lg-image").removeAttr("style data-scale"), this.pageX = u(window).width() / 2, this.pageY = u(window).height() / 2 + u(window).scrollTop()
        }, t.prototype.zoomSwipe = function () {
            var s, o = this, n = {}, r = {}, a = !1, l = !1, c = !1, d = 0;
            o.core.$slide.on("touchstart.lg", function (t) {
                var e;
                o.core.$outer.hasClass("lg-zoomed") && (e = o.core.$slide.eq(o.core.index).find(".lg-object"), s = o.core.$slide.eq(o.core.index).find(".lg-img-rotate")[0], d = o.getCurrentRotation(s), e = o.getDragAllowedAxises(e, Math.abs(d)), c = e.allowY, ((l = e.allowX) || c) && (t.preventDefault(), n = o.getSwipeCords(t, Math.abs(d))))
            }), o.core.$slide.on("touchmove.lg", function (t) {
                var e, i;
                o.core.$outer.hasClass("lg-zoomed") && (e = o.core.$slide.eq(o.core.index).find(".lg-img-wrap"), t.preventDefault(), a = !0, r = o.getSwipeCords(t, Math.abs(d)), o.core.$outer.addClass("lg-zoom-dragging"), i = c ? -Math.abs(e.attr("data-y")) + (r.y - n.y) * o.getModifier(d, "Y", s) : -Math.abs(e.attr("data-y")), t = l ? -Math.abs(e.attr("data-x")) + (r.x - n.x) * o.getModifier(d, "X", s) : -Math.abs(e.attr("data-x")), (15 < Math.abs(r.x - n.x) || 15 < Math.abs(r.y - n.y)) && (o.core.s.useLeftForZoom ? e.css({
                    left: t + "px",
                    top: i + "px"
                }) : e.css("transform", "translate3d(" + t + "px, " + i + "px, 0)")))
            }), o.core.$slide.on("touchend.lg", function () {
                o.core.$outer.hasClass("lg-zoomed") && a && (a = !1, o.core.$outer.removeClass("lg-zoom-dragging"), o.touchendZoom(n, r, l, c, d))
            })
        }, t.prototype.zoomDrag = function () {
            var s, o = this, n = {}, r = {}, a = !1, l = !1, c = !1, d = !1, h = 0;
            o.core.$slide.on("mousedown.lg.zoom", function (t) {
                s = o.core.$slide.eq(o.core.index).find(".lg-img-rotate")[0], h = o.getCurrentRotation(s);
                var e = o.core.$slide.eq(o.core.index).find(".lg-object"), e = o.getDragAllowedAxises(e, Math.abs(h));
                d = e.allowY, c = e.allowX, o.core.$outer.hasClass("lg-zoomed") && u(t.target).hasClass("lg-object") && (c || d) && (t.preventDefault(), n = o.getDragCords(t, Math.abs(h)), a = !0, o.core.$outer.scrollLeft += 1, --o.core.$outer.scrollLeft, o.core.$outer.removeClass("lg-grab").addClass("lg-grabbing"))
            }), u(window).on("mousemove.lg.zoom", function (t) {
                var e, i;
                a && (e = o.core.$slide.eq(o.core.index).find(".lg-img-wrap"), l = !0, r = o.getDragCords(t, Math.abs(h)), o.core.$outer.addClass("lg-zoom-dragging"), i = d ? -Math.abs(e.attr("data-y")) + (r.y - n.y) * o.getModifier(h, "Y", s) : -Math.abs(e.attr("data-y")), t = c ? -Math.abs(e.attr("data-x")) + (r.x - n.x) * o.getModifier(h, "X", s) : -Math.abs(e.attr("data-x")), o.core.s.useLeftForZoom ? e.css({
                    left: t + "px",
                    top: i + "px"
                }) : e.css("transform", "translate3d(" + t + "px, " + i + "px, 0)"))
            }), u(window).on("mouseup.lg.zoom", function (t) {
                a && (a = !1, o.core.$outer.removeClass("lg-zoom-dragging"), !l || n.x === r.x && n.y === r.y || (r = o.getDragCords(t, Math.abs(h)), o.touchendZoom(n, r, c, d, h)), l = !1), o.core.$outer.removeClass("lg-grabbing").addClass("lg-grab")
            })
        }, t.prototype.touchendZoom = function (t, e, i, s, o) {
            var n = this, r = n.core.$slide.eq(n.core.index).find(".lg-img-wrap"),
                a = n.core.$slide.eq(n.core.index).find(".lg-object"),
                l = n.core.$slide.eq(n.core.index).find(".lg-img-rotate")[0],
                c = -Math.abs(r.attr("data-x")) + (e.x - t.x) * n.getModifier(o, "X", l),
                l = -Math.abs(r.attr("data-y")) + (e.y - t.y) * n.getModifier(o, "Y", l),
                o = n.getPossibleDragCords(a, Math.abs(o));
            (15 < Math.abs(e.x - t.x) || 15 < Math.abs(e.y - t.y)) && (s && (l <= -o.maxY ? l = -o.maxY : l >= -o.minY && (l = -o.minY)), i && (c <= -o.maxX ? c = -o.maxX : c >= -o.minX && (c = -o.minX)), s ? r.attr("data-y", Math.abs(l)) : l = -Math.abs(r.attr("data-y")), i ? r.attr("data-x", Math.abs(c)) : c = -Math.abs(r.attr("data-x")), n.core.s.useLeftForZoom ? r.css({
                left: c + "px",
                top: l + "px"
            }) : r.css("transform", "translate3d(" + c + "px, " + l + "px, 0)"))
        }, t.prototype.destroy = function () {
            var t = this;
            t.core.$el.off(".lg.zoom"), u(window).off(".lg.zoom"), t.core.$slide.off(".lg.zoom"), t.core.$el.off(".lg.tm.zoom"), t.resetZoom(), clearTimeout(t.zoomabletimeout), t.zoomabletimeout = !1
        }, u.fn.lightGallery.modules.zoom = t
    }()
}), function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function (i) {
    !function () {
        "use strict";

        function t(t) {
            return this.core = i(t).data("lightGallery"), this.core.s = i.extend({}, e, this.core.s), this.core.s.hash && (this.oldHash = window.location.hash, this.init()), this
        }

        var e = {hash: !0};
        t.prototype.init = function () {
            var e, s = this;
            s.core.$el.on("onAfterSlide.lg.tm", function (t, e, i) {
                history.replaceState ? history.replaceState(null, null, window.location.pathname + window.location.search + "#lg=" + s.core.s.galleryId + "&slide=" + i) : window.location.hash = "lg=" + s.core.s.galleryId + "&slide=" + i
            }), i(window).on("hashchange.lg.hash", function () {
                e = window.location.hash;
                var t = parseInt(e.split("&slide=")[1], 10);
                -1 < e.indexOf("lg=" + s.core.s.galleryId) ? s.core.slide(t, !1, !1) : s.core.lGalleryOn && s.core.destroy()
            })
        }, t.prototype.destroy = function () {
            this.core.s.hash && (this.oldHash && this.oldHash.indexOf("lg=" + this.core.s.galleryId) < 0 ? history.replaceState ? history.replaceState(null, null, this.oldHash) : window.location.hash = this.oldHash : history.replaceState ? history.replaceState(null, document.title, window.location.pathname + window.location.search) : window.location.hash = "", this.core.$el.off(".lg.hash"))
        }, i.fn.lightGallery.modules.hash = t
    }()
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (o) {
    !function () {
        "use strict";

        function t(t) {
            return this.core = o(t).data("lightGallery"), this.core.s = o.extend({}, e, this.core.s), this.core.s.share && this.init(), this
        }

        var e = {
            share: !0,
            facebook: !0,
            facebookDropdownText: "Facebook",
            twitter: !0,
            twitterDropdownText: "Twitter",
            pinterest: !0,
            pinterestDropdownText: "Pinterest"
        };
        t.prototype.init = function () {
            var s = this,
                t = '<button type="button" aria-label="Share" id="lg-share" class="lg-icon" aria-haspopup="true" aria-expanded="false"><ul class="lg-dropdown" style="position: absolute;">';
            t += s.core.s.facebook ? '<li><a id="lg-share-facebook" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.facebookDropdownText + "</span></a></li>" : "", t += s.core.s.twitter ? '<li><a id="lg-share-twitter" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.twitterDropdownText + "</span></a></li>" : "", t += s.core.s.pinterest ? '<li><a id="lg-share-pinterest" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.pinterestDropdownText + "</span></a></li>" : "", t += "</ul></button>", this.core.$outer.find(".lg-toolbar").append(t), this.core.$outer.find(".lg").append('<div id="lg-dropdown-overlay"></div>'), o("#lg-share").on("click.lg", function () {
                s.core.$outer.toggleClass("lg-dropdown-active");
                var t = o("#lg-share").attr("aria-expanded");
                o("#lg-share").attr("aria-expanded", "true" !== t)
            }), o("#lg-dropdown-overlay").on("click.lg", function () {
                s.core.$outer.removeClass("lg-dropdown-active"), o("#lg-share").attr("aria-expanded", !1)
            }), s.core.$el.on("onAfterSlide.lg.tm", function (t, e, i) {
                setTimeout(function () {
                    o("#lg-share-facebook").attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(s.getSahreProps(i, "facebookShareUrl") || window.location.href)), o("#lg-share-twitter").attr("href", "https://twitter.com/intent/tweet?text=" + s.getSahreProps(i, "tweetText") + "&url=" + encodeURIComponent(s.getSahreProps(i, "twitterShareUrl") || window.location.href)), o("#lg-share-pinterest").attr("href", "http://www.pinterest.com/pin/create/button/?url=" + encodeURIComponent(s.getSahreProps(i, "pinterestShareUrl") || window.location.href) + "&media=" + encodeURIComponent(s.getSahreProps(i, "src")) + "&description=" + s.getSahreProps(i, "pinterestText"))
                }, 100)
            })
        }, t.prototype.getSahreProps = function (t, e) {
            var i;
            return this.core.s.dynamic ? this.core.s.dynamicEl[t][e] : (i = this.core.$items.eq(t).attr("href"), t = this.core.$items.eq(t).data(e), "src" === e && i || t)
        }, t.prototype.destroy = function () {
        }, o.fn.lightGallery.modules.share = t
    }()
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (i) {
    !function () {
        "use strict";

        function t(t) {
            return this.core = i(t).data("lightGallery"), this.core.s = i.extend({}, e, this.core.s), this.core.s.rotate && this.core.doCss() && this.init(), this
        }

        var e = {rotate: !0, rotateLeft: !0, rotateRight: !0, flipHorizontal: !0, flipVertical: !0};
        t.prototype.buildTemplates = function () {
            var t = "";
            this.core.s.flipVertical && (t += '<button aria-label="Flip vertical" class="lg-flip-ver lg-icon"></button>'), this.core.s.flipHorizontal && (t += '<button aria-label="flip horizontal" class="lg-flip-hor lg-icon"></button>'), this.core.s.rotateLeft && (t += '<button aria-label="Rotate left" class="lg-rotate-left lg-icon"></button>'), this.core.s.rotateRight && (t += '<button aria-label="Rotate right" class="lg-rotate-right lg-icon"></button>'), this.core.$outer.find(".lg-toolbar").append(t)
        }, t.prototype.init = function () {
            var s = this;
            this.buildTemplates(), this.rotateValuesList = {}, this.core.$el.on("onAferAppendSlide.lg.tm.rotate", function (t, e) {
                s.core.$slide.eq(e).find(".lg-img-wrap").wrap('<div class="lg-img-rotate"></div>')
            }), this.core.$outer.find(".lg-rotate-left").on("click.lg", this.rotateLeft.bind(this)), this.core.$outer.find(".lg-rotate-right").on("click.lg", this.rotateRight.bind(this)), this.core.$outer.find(".lg-flip-hor").on("click.lg", this.flipHorizontal.bind(this)), this.core.$outer.find(".lg-flip-ver").on("click.lg", this.flipVertical.bind(this)), this.core.$el.on("onBeforeSlide.lg.tm.rotate", function (t, e, i) {
                s.rotateValuesList[i] || (s.rotateValuesList[i] = {rotate: 0, flipHorizontal: 1, flipVertical: 1})
            })
        }, t.prototype.applyStyles = function () {
            this.core.$slide.eq(this.core.index).find(".lg-img-rotate").css("transform", "rotate(" + this.rotateValuesList[this.core.index].rotate + "deg) scale3d(" + this.rotateValuesList[this.core.index].flipHorizontal + ", " + this.rotateValuesList[this.core.index].flipVertical + ", 1)")
        }, t.prototype.getCurrentRotation = function (t) {
            if (!t) return 0;
            t = window.getComputedStyle(t, null), t = t.getPropertyValue("-webkit-transform") || t.getPropertyValue("-moz-transform") || t.getPropertyValue("-ms-transform") || t.getPropertyValue("-o-transform") || t.getPropertyValue("transform") || "none";
            if ("none" !== t) {
                t = t.split("(")[1].split(")")[0].split(",");
                if (t) {
                    t = Math.round(Math.atan2(t[1], t[0]) * (180 / Math.PI));
                    return t < 0 ? t + 360 : t
                }
            }
            return 0
        }, t.prototype.rotateLeft = function () {
            this.rotateValuesList[this.core.index].rotate -= 90, this.applyStyles()
        }, t.prototype.rotateRight = function () {
            this.rotateValuesList[this.core.index].rotate += 90, this.applyStyles()
        }, t.prototype.flipHorizontal = function () {
            var t = this.core.$slide.eq(this.core.index).find(".lg-img-rotate")[0], t = this.getCurrentRotation(t),
                t = 90 !== t && 270 !== t ? "flipHorizontal" : "flipVertical";
            this.rotateValuesList[this.core.index][t] *= -1, this.applyStyles()
        }, t.prototype.flipVertical = function () {
            var t = this.core.$slide.eq(this.core.index).find(".lg-img-rotate")[0], t = this.getCurrentRotation(t),
                t = 90 !== t && 270 !== t ? "flipVertical" : "flipHorizontal";
            this.rotateValuesList[this.core.index][t] *= -1, this.applyStyles()
        }, t.prototype.destroy = function () {
            this.core.$el.off(".lg.tm.rotate"), this.rotateValuesList = {}
        }, i.fn.lightGallery.modules.rotate = t
    }()
}), function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? module.exports = t : t(jQuery)
}(function (d) {
    function e(t) {
        var e, i = t || window.event, s = f.call(arguments, 1), o = 0, n = 0, r = 0, a = 0, l = 0, c = 0;
        if ((t = d.event.fix(i)).type = "mousewheel", "detail" in i && (r = -1 * i.detail), "wheelDelta" in i && (r = i.wheelDelta), "wheelDeltaY" in i && (r = i.wheelDeltaY), "wheelDeltaX" in i && (n = -1 * i.wheelDeltaX), "axis" in i && i.axis === i.HORIZONTAL_AXIS && (n = -1 * r, r = 0), o = 0 === r ? n : r, "deltaY" in i && (o = r = -1 * i.deltaY), "deltaX" in i && (n = i.deltaX, 0 === r && (o = -1 * n)), 0 !== r || 0 !== n) {
            1 === i.deltaMode ? (o *= e = d.data(this, "mousewheel-line-height"), r *= e, n *= e) : 2 === i.deltaMode && (o *= e = d.data(this, "mousewheel-page-height"), r *= e, n *= e);
            var a = Math.max(Math.abs(r), Math.abs(n));
            return g && !(a < g) || u(i, g = a) && (g /= 40), u(i, a) && (o /= 40, n /= 40, r /= 40), o = Math[1 <= o ? "floor" : "ceil"](o / g), n = Math[1 <= n ? "floor" : "ceil"](n / g), r = Math[1 <= r ? "floor" : "ceil"](r / g), m.settings.normalizeOffset && this.getBoundingClientRect && (a = this.getBoundingClientRect(), l = t.clientX - a.left, c = t.clientY - a.top), t.deltaX = n, t.deltaY = r, t.deltaFactor = g, t.offsetX = l, t.offsetY = c, t.deltaMode = 0, s.unshift(t, o, n, r), p && clearTimeout(p), p = setTimeout(h, 200), (d.event.dispatch || d.event.handle).apply(this, s)
        }
    }

    function h() {
        g = null
    }

    function u(t, e) {
        return m.settings.adjustOldDeltas && "mousewheel" === t.type && e % 120 == 0
    }

    var p, g, t = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
        i = "onwheel" in document || 9 <= document.documentMode ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
        f = Array.prototype.slice;
    if (d.event.fixHooks) for (var s = t.length; s;) d.event.fixHooks[t[--s]] = d.event.mouseHooks;
    var m = d.event.special.mousewheel = {
        version: "3.1.12", setup: function () {
            if (this.addEventListener) for (var t = i.length; t;) this.addEventListener(i[--t], e, !1); else this.onmousewheel = e;
            d.data(this, "mousewheel-line-height", m.getLineHeight(this)), d.data(this, "mousewheel-page-height", m.getPageHeight(this))
        }, teardown: function () {
            if (this.removeEventListener) for (var t = i.length; t;) this.removeEventListener(i[--t], e, !1); else this.onmousewheel = null;
            d.removeData(this, "mousewheel-line-height"), d.removeData(this, "mousewheel-page-height")
        }, getLineHeight: function (t) {
            var e = d(t), t = e["offsetParent" in d.fn ? "offsetParent" : "parent"]();
            return t.length || (t = d("body")), parseInt(t.css("fontSize"), 10) || parseInt(e.css("fontSize"), 10) || 16
        }, getPageHeight: function (t) {
            return d(t).height()
        }, settings: {adjustOldDeltas: !0, normalizeOffset: !0}
    };
    d.fn.extend({
        mousewheel: function (t) {
            return t ? this.bind("mousewheel", t) : this.trigger("mousewheel")
        }, unmousewheel: function (t) {
            return this.unbind("mousewheel", t)
        }
    })
});
